const messages = {
  he: {
    general: {
      langCode: "he",
      backToMainPage: "חזרה לדף הראשי",
      attention1: "שים לב!",
      all: "הכל",
      errorNo: "מספר שגיאה",
      attention: "לתשומת ליבך!",
      hello: "שלום",
      dpiSetting: "איכות ספרי PDF",
      bookQuality: "איכות התמונה",
      success_action: "הפעולה בוצעה בהצלחה",
      error_action: "התרחשה שגיאה",
      old_password: "סיסמה ישנה",
      new_password: "סיסמה חדשה",
      title: "אוצר החכמה",
      confirm: "אישור",
      disconnect: "נתק",
      wrong_psw: "סיסמה שגויה",
      fax: "פקס",
      yes: "כן",
      no: "לא",
      open: "פתח",
      close: "סגור",
      info: "מידע",
      rename: "שנה שם",
      delete: "מחק",
      edit: "עריכה",
      save: "שמור",
      noSave: "אל תשמור",
      save2: "שמירה",
      remove: "הסר",
      remove2: "מחיקה",
      constName: "לא ניתן להשתמש בשם זה - שם זה שמור לצרכי מערכת",
      value: "ערך",
      content: "תוכן",
      noResults: "אין תוצאות",
      noFindResults: "לא נמצאו תוצאות",
      noValues: "אין ערכים",
      book: "ספר",
      failed: "הפעולה נכשלה",
      doSearchNew: "בצע חיפוש חדש או פתח רשימה שמורה",
      openListBook: "פתח רשימת ספרים",
      selectListBook: "בחר רשימת ספרים",
      cancelSelect: "בטל בחירה",
      selectAll: "בחר הכל",
      reverseSelect: "הפוך בחירה",
      exportSelectBook: "יצוא ספרים מסומנים",
      exportExel: "יצוא לEXCEL",
      exportPdf: "יצוא לPDF",
      date: "תאריך",
      type: "סוג",
      allBookList: "רשימת הספרים המלאה",
      activeStore: "מאגר פעיל",
      books: "ספרים",
      pages: "עמודים",
      loadMoreResults: "טען עוד תוצאות",
      name: "שם",
      returnDefults: "חזור לברירת מחדל",
      allRight: "המשתמש בתוכנה שלא נרכשה כדין עובר על איסור גזל ©",
      ver_prefix: "הגירסא שברשותך ",
      ver_postix: " אינה מעודכנת",
      ver_srv: "גירסא אחרונה ",
      cancel: "ביטול",
      cancel2: "בטל",
      do: "בצע",
      clearCache: "נקה מטמון",
      restartOnSuccess: "הפעולה בוצעה בהצלחה - יש להפעיל את התוכנה מחדש",
      change: "שנה",
      ofResults: "מתוך",
      results: "תוצאות",
      selectBook: "בחר ספר",
      selectPage: "עמוד",
      add: "הוסף",
      notAllow: "לא מורשה",
      select: "בחר",
      backe: "חזור",
      back: "חזור",
      adding: "מוסיף",
      myComputer: "המחשב שלי",
      added1: "נוספו",
      padeFrom: " עמודים מתוך",
      exit: "צא",
      view1: "תצוגת",
      currentPage: "עמוד נוכחי",
      new: "חדש",
      text: "טקסט",
      menu: "תפריט",
      lastEdit: "נערך לאחרונה:",
      all: "כל",
      theBook: "הספר",
      sortNew: "מיין עכשיו",
      error: "שגיאה",
      fromBook: "מספר",
      toBook: "אל ספר",
      img: "תמונה",
      pages: "עמודים",
      page: "עמוד",
      page1: "עמוד",
      nameBook: "שם ספר",
      desc: "תאור",
      or: "או",
      play: "הפעל",
      ImportantMsg: "הודעות חשובות",
      gzirim: "גזירים",
      id: "מזהה",
      searchIn: "חפש ב",
      view: "הצג",
      hide: "הסתר",
      resetDefaults: "שחזר הגדרות ברירת מחדל",
      enterId: "",
      mef: "מפרשי האוצר",
      enterBookId: "הזן מספר ספר",
      removeAllList: "רוקן את כל הרשימה",
      successSavedList: "רשימת הספרים נוצרה בהצלחה",
      errorSavedList: "תקלה ביצירת הרשימה, נסה שוב",
      cancelHiddenBook: "בטל הסתרה",
      sendSuccess: "נשלח בהצלחה!",
      sendError: "תקלה בשליחת מייל",
      endBook: "סוף הספר",
      enterPassword: "הכנס סיסמא",
      errorPassword: "סיסמא שגויה",
      saveChanges: "שמור שינויים",
      outof: "מתוך",
      warning: "אזהרה",
      noBooks: "לא נמצאו ספרים ליצירת הרשימה",
      printError: "תקלה בהדפסה",
      missingPlugin: "חסר רכיב ליצוא רשימות. אנא פנה לתמיכה.",
      setBookmarkPosition: "קבע מיקום סימניה",
      jumpToBookmarkPosition: "עבור לסימניה",
      canDragToMove: "ניתן לגרור להזזה",
    },
    times: {
      second: "שניות",
    },
    selectBook: {
      hideSelectBook: "הסתר ספרים מסומנים",
      addSelectBookToQuick: "הוסף ספרים מסומנים לכפתור גישה מהירה",
      removeBookQ: "האם אתה בטוח שברצונך להסיר ספר זה מהרשימה?",
      removeBooksQ: "האם אתה בטוח שברצונך להסיר ספרים אלו מהרשימה?",
      deleteBookInList: "מחיקת ספרים מהרשימה",
      removeSelectBook: "מסיר ספרים נבחרים מהרשימה",
    },
    userDefaultFolders: {
      root: "תיקיות וקבצים אישיים",
      rootSystem: "תיקיות וקבצי מערכת",
      favorites: "מועדפים",
      tsiyun: "הציונים שלי",
      desktops: "שולחנות עבודה",
      customsort: "מיונים מותאמים אישית",
      comments: "הערות",
      keys: "מפתחות",
      markers: "הדגשות",
      recentbooks: "ספרים אחרונים שנפתחו",
      qckbtn: "כפתורי גישה מהירה",
      userbooks: "ספרים אישיים",
      pdfbooks: "ספרי PDF",
      hiddenbooks: "ספרים מוסתרים",
      youSureToDeleteAll:
        "האם אתה בטוח שברצונך למחוק את כל הספרים האחרונים שנפתחו?",
      deleteAllRecentBooks: "ריקון ספרים שנפתחו",
    },
    rightMenu: {
      copy: "העתק",
      cut: "גזור",
      paste: "הדבק",
      selectSymboleFolder: "בחר סמל לתיקיה",
      selectSymboleFile: "בחר סמל לרשימה",
      pinHeadList: "נעץ בראש הרשימה",
      symbol: "סמלים",
      details: "פרטים",
      list: "רשימה",
      tree: "עץ",
      viewTree: "תצוגת עץ",
      createFolder: "צור תיקיה חדשה",
      rename: "שנה שם",
      view: "תצוגה",
      properties: "מאפיינים",
    },
    login: {
      chooseLand: "בחר מדינה",
      name: "שם פרטי",
      lastName: "שם משפחה",
      user: "שם משתמש",
      password: "סיסמא",
      createdUser: "יצירת משתמש",
      creatNeweUser: "צור משתמש",
      login: "התחבר",
      logout: "התנתק",
      logoutSubUser: "נתק משתמש מידע אישי",
      login2: "התחברות",
      logoutSuccess: "התנתקת בהצלחה",
      createSubUser: "יצירת משתמש למידע אישי",
      enterUserName: "הכנס כתובת מייל",
      enterPassword: "הכנס סיסמא",
      createUser: "צור משתמש",
      emailExists: "משתמש כבר קיים",
      successCreateSubUser: "משתמש עבור מידע אישי נוצר בהצלחה",
      successLoginSubUser: "התחברת בהצלחה",
      noUser: "כתובת מייל או סיסמא שגויים",
      invalidContactInfo: "שם משתמש או סיסמא שגויים",
      errorLogging: "תקלה בהתחברות: ",
      enterCurrentPassword: "הכנס סיסמא נוכחית",
      enterNewPassword: "הכנס סיסמא חדשה",
      repeatPassword: "הכנס סיסמא חדשה שנית",
      changePassword: "שנה סיסמא",
      passwordValidationFailed: "אימות סיסמא נכשל",
      sentPasswordMail: "קישור לשחזור הסיסמא נשלח לכתובת המייל שלך",
      enterUserName1: "הכנס שם משתמש",
      enterAll: "מלא את כל הפרטים",
      goToSite: "למעבר לאוצר החכמה המקוון",
      noMail: "כתובת מייל אינה מעודכנת בחשבון שלך. נא לעדכן במשרד.",
      noUser: "שם משתמש או סיסמא שגויים",
      noFreeStation: "כל העמדות תפוסות. נסה שוב מאוחר יותר",
      forgotPassword: "שכחתי סיסמא",
      subUserConnected: "הינך מחובר למשתמש",
      connectAsVisitor: "הכנס כאורח",
      noValidLicense: "אין לך מנוי פעיל",
      dontshow: "אל תציג הודעה זו שוב",
      selectApps: "סמן את התוכנות שתרצה להפעיל",
      noFreeStation1: "כל העמדות תפוסות",
      discconctOtherConnection: "נותקת עקב התחברות במקום אחר",
      errorRestorePass: "תקלה בשחזור הסיסמא",
      errorChangePass: "תקלה בשינוי הסיסמא",
      invalidLink: "הקישור אינו תקין או שפג תוקפו",
      passwordChangeSuccess: "הסיסמא הוחלפה בהצלחה",
      weakPassword: "סיסמא חלשה",
      passReset: "אוצר החכמה המקוון - שחזור סיסמא",
      notConnectedNow: "לא מחובר כעת",
      enter: "הכנס",
      newUser: "משתמש חדש",
      existUser: "משתמש קיים",
      register: "הירשם",
      address: "כתובת",
      phone: "טלפון",
      passwordValidation: "אימות סיסמא",
      userExists: "שם משתמש כבר קיים",
      registerFailed: "תקלה בהרשמה. נסה שוב מאוחר יותר.",
      registerFlow:
        "בדקות אילו נשלח מייל לכתובת שלך. יש ללחוץ על הקישור במייל על מנת להשלים את תהליך ההרשמה.",
      registerValidating: "מבצע אימות נתונים",
      registerFailed: "תהליך ההרשמה נכשל. נסה להרשם מחדש.",
      registerSucceed: "תהליך ההרשמה הושלם בהצלחה. הינך מועבר לאוצר המקוון.",
      permission:
        "* שם המשתמש והסיסמה נועדו לשימושך האישי בלבד ואינך רשאי למסור אותם לאחרים.",
      mailError: "כתובת מייל שגויה",
      email: "אימייל",
      cellPhone: "טלפון נייד",
      city: "עיר",
      zipCode: "מיקוד",
      land: "ארץ",
      createAccount: "ליצירת חשבון",
      BLOCKED: "המשתמש חסום. אנא פנה לתמיכה.",
      NAIP: "התחברת מכתובת IP לא מורשית.",
    },
    store: {
      activeStore: "מאגר פעיל",
      setActiveStore: "קבע מאגר פעיל",
      setStoreTemp: "קבע מאגר באופן זמני",
    },
    hisory: {
      showAll: "הצג את כל ההסטוריה",
      inContentBook: "הסטורית חיפוש בתוכן הספרים",
      inNameBookAndAuthor: "הסטורית חיפוש שם ספר / מחבר",
      noValues: "אין ערכים",
      isList: "רשימות ספרים",
    },
    comments: {
      comment: "הערה",
      comments: "הערות",
      success_save: "הערה נשמרה בהצלחה",
      success_add: "הערה נוספה בהצלחה",
    },
    keys: {
      key: "מפתח",
      keys: "מפתחות",
      success_save: "המפתח נשמר בהצלחה",
      success_add: "המפתח נוסף בהצלחה",
      placeHolder: "חיפוש ערכים במפתחות",
    },
    links: {
      link: "קישור",
      links: "קישורים",
      success_save: "הקישור נשמר בהצלחה",
      success_add: "הקישור נוסף בהצלחה",
    },
    desktops: {
      names: "שולחנות עבודה",
      name: "שולחן עבודה",
      default: "קבע כברירת מחדל",
      lastDesk: "שמור שולחן עבודה ביציאה",
      lastOpenDesk: "שולחן עבודה אחרון",
      saveDesk: "שמור שולחן עבודה",
      nameNew: "הכנס שם לשולחן עבודה חדש",
      open: "פתח שולחן עבודה",
      dup: "קיים שולחן עבודה בשם זהה",
      deskname: "לא ניתן לשנות שם לשולחן עבודה אחרון",
      msgDelete: "האם אתה בטוח שברצונך למחוק שולחן עבודה בשם: ",
      resetDefault: "אפס ברירת מחדל",
      noSavedDesktop: "אין שולחנות עבודה שמורים",
      alredyExists: "כבר קיים שולחן עבודה בשם זה",
      doReplace: "האם ברצונך להחליף את שולחן העבודה הקיים?",
      errorSaving: "תקלה בשמירת שולחן עבודה אחרון",
    },
    searchInput: {
      placeHolder: "חפש שם ספר או מחבר",
      placeHolderById: "חפש לפי מזהה ספר",
    },
    folders: {
      openFolder: "פתח תיקיה",
      saveList: "שמור ספרים לרשימה",
      placeholderSearch: "חפש תיקיה או רשימת ספרים",
      numBook: "מספר ספרים",
      typeList: "סוג רשימה",
      systemFiles: "תיקיות וקבצי מערכת",
      mineFiles: "תיקיות וקבצים אישיים",
      addCurrList: "הוסף לרשימה זו",
      nameFile: "שם הקובץ",
      newList: "רשימה חדשה",
      addNewListAs: "מוסיף רשימה חדשה בשם",
      bookAdded: "הספר/ים התווספו לרשימת הספרים: ",
      exploreOtzar: "סייר האוצר",
      normalView: "תצוגה רגילה",
      filterTree: "סינון ממוקד",
      notSelectedFile: "לא נבחר קובץ",
      notSelectedFolder: "לא נבחרה תיקיה",
      okDeleteCurrentBook: "האם אתה בטוח שברצונך למחוק תיקיה זו?",
      okDeleteCurrentList: "האם אתה בטוח שברצונך למחוק רשימה זו?",
      favIst: "רשימת מועדפים",
      folderSystemList: "תיקית רשימות מערכת",
      folderLists: "תיקית רשימות",
      normalListBooks: "רשימת ספרים רגילה",
      listBooksFromFreeSearch: "רשימת ספרים מחיפוש חופשי",
      folderListSearch: "תקית רשימות חיפוש",
      notExistList: "רשימה זו אינה קיימת יותר",
      subMultySelect: "נושאים - בחירה מרובה",
      files: "קבצים",
      basicBooks: "ספרי יסוד",
      meforshim: "מפרשים",
      subject: "נושאים",
      maagarim: "מאגרים",
      textbooks: "ספרי טקסט",
      openFreeList: "פתח רשימות חיפוש שמורות",
      errorRenameBookQB: "תקלה בשינוי שם הספר",
    },
    printOptions: {
      printOpts: "אפשרויות הדפסה",

      colors: "צבעים",
      cgray: "שחור לבן",
      cfull: "צבעוני",
      layouts: "פריסה",
      lhorz: "לאורך",
      lvert: "לרוחב",
      copies: "עותקים",
      pagesPerSheet: "דפים בכל גיליון",
      margins: "שוליים",
      default: "ברירת מחדל",
      m_no_margins: "ללא",
      m_min: "מינימום",
      m_cust: "בהתאמה אישית",
      quailty: "איכות",
      page_size: "גודל נייר",
      pagesPerSheet: "דפים בכל גיליון",
    },
    lists: {
      randomBooks: "ספרים אקראים",
      mefarsheiAdafAyumi: "מפרשי הדף היומי",
      sifreiYesod: "ספרי יסוד",
      parashatAshavoa: "פרשת השבוע",
      hiddenBooks: "מוסתרים",
      openList: "פתח רשימה",
      mineBooks: "ספרים אישים",
      pdfBooks: "ספרי PDF",
      checkedBooks: "מסומנים",
      listNews: "רשימת חידושים",
    },
    propetiesFolder: {},
    toolbox: {
      fitHeight: "התאם לגובה",
      fitWidth: "התאם לרוחב",
      fullScreen: "מסך מלא",
      normalScreen: "חזור למסך רגיל",
      zoom: "הגדל",
      userExtens: "תוספות אישיות",
      favorites: "הוספה למועדפים",
      removefavorites: "הסר ממועדפים",
      print: "הדפסה",
      ocr: "טקסט או תמונה מהספר",
      searchInBook: "חיפוש בספר",
      link: "צור קישור לספר",
      mm: "הצג מראי מקומות",
      hidemm: "הסתר מראי מקומות",
      detailesBook: "פרטי ספר",
      maskToggle: "הצג/הסתר קטע נבחר",
      maskOn: "הסתר",
      maskOff: "הצג",
      mefToggle: "הפעל/כבה את מפרשי האוצר",
      mefOn: "הפעל את מפרשי האוצר",
      mefOff: "כבה את מפרשי האוצר",
      mefAreaOn: "הצג רשימת מפרשי האוצר",
      mefAreaOff: "הסתר רשימת מפרשי האוצר",
      mefToggleArea: "הצג/הסתר רשימת מפרשי האוצר",
      openBook: "פתח ספר בחלון",
      reset: "אפס",
      removeFs: "הסתר תוצאות חיפוש",
      showFs: "הצג תוצאות חיפוש",
      showMM: "הצג מראי מקומות",
      hideMM: "הסתר מראי מקומות",
      rotateImage: "סובב תמונה",
      guestNoPrint: "אורח אינו מורשה להדפיס",
      bookNoPrint: "ספר זה אינו מורשה להדפסה",
      openOnCurrentPage: "פתח ספר תמיד בעמוד זה",
      removeOpenOnCurrentPage: "בטל פתיחת ספר בעמוד ",
      startMefo: "הפעל את מפרשי האוצר",
    },
    mm: {
      mmToltipAccuracyH: "רמת דיוק: גבוהה",
      mmToltipAccuracyM: "רמת דיוק: בינונית",
      mmToltipAccuracyL: "רמת דיוק: נמוכה",
    },

    welcome: {
      welcomeOtzar: "ברוכים הבאים לאוצר החכמה",
      descTitle: "הספריה היהודית הממוחשבת הגדולה בעולם",
      howStart: "איך תרצה להתחיל?",
      openNewDesktop: "סייר שולחנות עבודה",
      openFromSavedDesktop: "פתח מתוך שולחנות עבודה שמורים",
      openLastDesktop: "שולחן עבודה אחרון",
      noSavedDesktop: "אין שולחנות עבודה שמורים.",
      howSavedDesktop: "איך שומרים שולחנות עבודה",
      suggestedListBook: "רשימות ספרים מוצעות",
      timeDay: "זמני היום",
      fromForumOtzar: "מתוך פורום אוצר החכמה",
      enterForum: "הכנס לפורום",
      notExistLoachshana: "לא קיים לוח שנה לשנה זאת או שקובץ הלוח פגום",
      hag: "חג",
    },
    tooltip: {
      booksInfo: "פרטי הספר",
      refresh: "רשימת הספרים המלאה",
      pin: "נעץ רשימה",
      unpin: "בטל נעיצה",
      infoBook: "פרטי הספר",
      booksAuthor: "לכל ספרי המחבר",
      addFavorites: "הוסף למועדפים",
      removeFavorites: "הסרה ממועדפים",
      historyBooks: "ספרים שנפתחו",
      filter: "סינון",
      searchIn: "חפש ברשימה",
      gzirim: "תצוגת גזירים",
      list: "תצוגת רשימה",
      garbage: "מחק ספרים נבחרים מהרשימה זו",
      saveSelect1: "שמור ספרים לרשימה",
      saveSelect: "שמור ספרים מסומנים",
      nextPage1: "לעמוד הבא",
      nextPage10: "10 עמודים קדימה",
      firstPage: "לעמוד הראשון",
      prevPage1: "לעמוד הקודם",
      prevPage10: "10 עמודים אחורה",
      lastPage: "לעמוד האחרון",
      addFavoritesList: "הוסף למועדפים",
      recentBook: "ספרים אחרונים",
      prevPasuk: "לפסוק הקודם",
      prevPerek: "לפרק הקודם",
      nextPasuk: "לפסוק הבא",
      nextPerek: "לפרק הבא",
    },
    userContactDetails: {
      nameAndLastname: "שם פרטי ומשפחה *",
      phone: "טלפון/ נייד *",
      email: "דואר אלקטרוני",
      emailRequired: "דואר אלקטרוני *",
      fieldError: "אחד מהשדות שגוי!",
      requiredFields: "* שדות חובה",
      send: "שלח",
      bugDetailsPlaceholder: "תיאור הבאג*",
      institutesName: "למוסדות - איש קשר",
      commentsPlaceholder: "* שאלות/ הערות:",
      clientName: "שם לקוח",
      phoneError: "מספר הטלפון שגוי",
      requiredError: "יש למלא את כל שדות החובה",
    },
    mainLanguage: {
      title: "הגדרות > הגדרות שפה",
      he: "עברית",
      en: "English",
      fr: "français",
    },
    settingsBookList: {
      title: "הגדרות > הגדרות רשימת ספרים",
    },
    actionBook: {
      saveList: "שמור לרשימה",
      saveNewList: "שמור ברשימה חדשה",
      addFavorits: "הוסף למועדפים",
      removeFavorits: "הסר ממועדפים",
      deleteFromList: "מחק מרשימה",
      addBtn: "הוסף לכפתור מהיר",
      hideBook: "הסתר ספר זה",
      exportBook: "ייצא ספר זה",
      exExcel: "ייצא לאקסל",
      exPdf: "ייצא לPDF",
      editBook: "ערוך ספר",
      exportSelectedResults: "יצוא תוצאות נבחרות",
      deletBookQ: "האם אתה בטוח שברצונך למחוק את הספר",
      completedDeleteBook:
        "מחיקת הספר הושלמה בהצלחה -העדכון יופיע לאחר ריענון הרשימה האוטומטי",
      deleteBook: "מחיקת ספר",
      failDeleteBook: "מחיקת הספר נכשלה",
      resetSuccessful: "האיפוס בוצע בהצלחה. התוכנה תפעיל את עצמה מחדש",
      resetError: "אירעה שגיאה באיפוס",
    },
    mainDisplaySetting: {
      title: "הגדרות > הגדרות תצוגה",
      colorfulness: "צבעוניות רקע",
      subColorfulness: "צבעוניות משנה",
      dark: "כהה",
      bright: "בהיר",
      archaic: "ארכאי",
      textSize: "גודל טקסט ברשימת ספרים",
      bookItemSize: "גודל שורה ברשימת הספרים",
      large: "גדול",
      compact: "קומפקטי",
      placementPopups: "מיקום חלוניות ציונים, עמודים ותוספות אישיות",
      left: "שמאל",
      right: "ימין",
      scrollDirection: "כיוון גלילת העמודים",
      directionUTD: "למעלה ללמטה",
      directionRTL: "ימין לשמאל",
      bookDisplayTab: "לשוניות תצוגת ספר",
      dislayBookTabInsteadOf: "פתח ספר חדש במקום הספר הקודם",
      dislayBookTabNewTab: "פתח ספר חדש בלשונית נוספת",
    },
    mareiMekomotSettings: {
      title: "הגדרות > הגדרות מראי מקומות",
      showMareiMakomRegularlyg: "הצג באופן קבוע מראי מקומות",
      showTooltip: "הצג חלונית כיתוב",
      hideTooltip: "אל תציג חלונית כיתוב",
      hideMm: "הסתר מראי מקומות",
      noHover: "אל תצבע רקע בריחוף",
      noTextColor: "אל תצבע טקסט",
      fullDisable: "השבת קישור בעת לחיצה",
      showYesodOnly: "הצג רק ספרי יסוד",
      settingMM: "הגדרות מראי מקומות במצב מושבת",
      settingMMActive: "הגדרות מראי מקומות במצב מופעל",
      on: "מופעל",
      off: "מושבת",
      showMM: "הצגת מראי מקומות:",
      allBooks: "מכל הספרים",
      syOnly: "מספרי יסוד בלבד",
    },
    contactUs: {
      companyAddress: "רחוב הרטום 9, הר חוצבים",
      companyPO: "ת.ד. 23609",
      companyLocation: "ירושלים 9777509",
      companyCountry: "ישראל",
      companyPhone: "טלפון רב-קווי: 02-5866078",
      companyFax: "פקס: 02-5712713",
      companyEmail: "אימייל: otzar@otzar.biz",
      activityTime: "ימים א'-ה' בין השעות 8:30-16:00",
      activityTimeNote1: "ניתן ליצור איתנו קשר באופן ישיר",
      activityTimeNote2: "או באמצעות הטופס המצורף",
      goToCompanyStaffDetails: "לרשימת כל צוות 'אוצר החכמה'",
      clickHere: "לחץ כאן",
      compantWhatsApp: "וואטסאפ:",
    },
    staffContactDetails: {
      whatsapp: "וואטסאפ:",
      management: "הנהלה",
      sales: "מכירות",
      otzarHamekuvan: "אוצר החכמה המקוון",
      development: "מחלקת פיתוח",
      technicalSupport: "תמיכה טכנית",
      bookkeeping: "הנהלת חשבונות",
      agents: "סוכנים",
      name: "שם מלא",
      job: "תאור תפקיד:",
      phone: "טלפון:",
      extension: "שלוחה:",
      email: "כתובת אימייל:",
      activityTime: "שעות פעילות:",
      address: "כתובת:",
      country: "ארץ:",
      state: "מדינה:",
      erez: {
        name: "ארז סלע",
        phone: "02-5866078",
        extension: "דרך המזכירות - 0",
        email: "otzar@otzar.biz",
        activityTime: "08:30-14:00",
      },
      bosmat: {
        name: "בשמת סלע",
        phone: "02-5866078",
        extension: "דרך המזכירות - 0",
        email: "otzar@otzar.biz",
        activityTime: "08:30-15:00",
      },
      miriam: {
        name: "רויה שוורץ",
        job: "שירות לקוחות ומכירות",
        phone: "02-5866078",
        extension: "206",
        email: "otzar@otzar.biz",
        activityTime: "08:30-14:30",
      },
      dina: {
        name: "דינה סעדה",
        job: "ראש צוות",
        phone: "02-5866078",
        extension: "208",
        email: "dina@otzar.biz",
        activityTime: "08:00-15:00",
      },
      krois: {
        name: "משה קפלן",
        job: "תמיכה טכנית",
        phone: "02-5866078",
        extension: "218",
        email: "kaplan@otzar.biz",
        activityTime: "09:00-16:00",
      },
      berman: {
        name: "דוד ברמן",
        job: "הנהלת חשבונות",
        phone: "02-5866078",
        extension: "203",
        email: "gg@otzar.biz",
        activityTime: "10:00-16:00",
      },
      rabinovitz: {
        name: 'רבינוביץ דוד - ארה"ב',
        job: "מכירות ועדכונים",
        phone: "1.917-5380812 ++",
        email: "info@judaicasoftware.com",
        address: "45 Lee Av.",
        country: "Brooklyn NY 11211",
        state: "USA",
      },
      aharonSela: {
        name: "אהרן סלע - קנדה",
        job: "מכירות ועדכונים",
        phone: "1-438-878-7674",
        phone2: "+1-438-878-7674",
        email: "aharoni111@gmail.com",
        address: "Durocher 6175",
        country: "Montreal H2V3Y7",
        state: "Canada",
      },
      katzin: {
        name: "משה קצין - מקסיקו",
        job: "מכירות ועדכונים",
        phone2: "+525555011709",
        email: "otzarmex@gmail.com",
        address: "Juan Racine 120 - 301",
        country: "Polanco CDMX 11510",
        state: "Mexico",
      },
    },
    freeSearchInput: {
      advancedMessage: "שפר את החיפוש שלך באמצעות:",
      placeHolder: "חפש בתוכן הספרים",
      placeHolderInBook: "חפש בתוכן הספר",
      searchInCurrentPage: "חפש בעמוד נוכחי בלבד",
      searchInAllBook: "חפש בכל הספר",
      searchInMeforshim: "חפש במפרשים",
      advancedSearch: "מתקדם",
      advancedSearch2: "חיפוש מתקדם",
      keyboardSC: "קיצורי מקלדת",
      search: "חפש",
      clear: "נקה",
      learn: "למד עוד",
      noAddMoreOneCharacter: "אין להוסיף יותר מתו מיוחד אחד",
      selectWordToComplete: "בחר מילה להשלמה",
      exportREsults: "ייצוא תוצאות חיפוש חופשי",
      exportREsultsToList: "הדפס רשימה",
      limitedList: "ברשימה מוגבלת",
      advancedOptions: {
        concatTitle: "הצמדת מילים",
        shimushTitle: "אותיות שימוש",
        inOrderTitle: "לפי סדר המילים",
        spaceTitle: "מרחק בין מילים",
        negTitle: "שלילת מילה",
        altTitle: "מילים חילופיות",
        MCTitle: "כתיב מלא וחסר",
        ShaarTitle: "חפש בעמודים ראשונים בכל ספר",
        RTTitle: "ראשי תיבות",
        nirdafotTitle: "מילים נרדפות",
        OCRTitle: "תקוני OCR",
        completeTitle: "השלמת מילה",
        anotherTitle: "חיפוש נוסף",
        concatMessage: "סמן את המילים שברצונך להצמיד",
        shimushMessage: "סמן את המילים להוספת אותיות שימוש",
        inOrderMessage: "",
        concatDescription:
          'הצמד את צמד המילים אותן תרצה לחפש כשהן צמודות זו לזו, ע"י סימון בתיבה שביניהן:',
        shimushDescription: "באילו מילים תרצה לכלול גם אותיות שימוש?",
        inOrderDescription:
          "הצג את התוצאות בהן מופיעות מילות החיפוש לפי סדר כתיבתן בשורת החיפוש",
        spaceDescription:
          "כתוב (בתיבה שבין המילים) את המרחק המקסימלי של התיבות שיהיו בין מילות החיפוש:",
        negDescription: "אילו מילים לא יופיעו בתוצאות החיפוש?",
        altDescription:
          "בתוצאות החיפוש כלול גם מילים חילופיות למילות החיפוש. \n(בחר מהרשימה או הוסף בעצמך):",
        completeDescription:
          "  כשחלק מהמילה עשוי להכתב באפשרויות כתיב רבות (או שאינו ידוע) ניתן לכתוב בשדה החיפוש את חלק המילה הידוע לך, ולהגדיר את מיקום החלק הבלתי ידוע של המילה בתחילת המילה, בסופה או בתוכה. ,",
        completeDescriptionShort:
          "הוסף במקום המתאים * למספר תוים, ? לתו אחד בודד או ! למקסימום תוים",
        anotherDescription:
          "בצע חיפוש חופשי נוסף (או כמה חיפושים נוספים במקביל) וקבל ברשימת הספרים תוצאות חיפוש של כל החיפושים שבצעת במקביל",
        negBtn: "שלול",
        placeNegInput: "שלול מילה",
        keyboardSC: "קיצור מקלדת",
        altOption1:
          "כלול בתוצאות החיפוש גם מילים נרדפות ממאגר המילים הנרדפות של התוכנה",
        altOption2: "כלול גם תיקוני החלפת אותיות ב OCR ",
        altOption2_2:
          '(OCR) אפשרות הוספת תוצאות נוספות לחיפוש ע"י חיפוש מילים אותם תוכנת המרת תמונת הספר לטקסט תרגמה בטעות לאותיות הדומות לאות המקורית (לדוגמא: ד=ר, ט=מ)',
        altOption3: "כלול בחיפוש גם תוצאות הנכתבות בכתיב מלא/חסר",
        altOption4:
          "כלול בתוצאות החיפוש גם ראשי תיבות פתוחות / סגורות של מילות החיפוש:",
        altOption5: "הכנס מילה חילופית נוספת",
        altOption6: "הוסף",
        altOption7: "הכנס ראשי תיבות",
        addNewAltWord: "הוסף מילה חילופית חדשה לרשימה",
        basicWord: "מילת בסיס",
        altWord: "מילה חילופית",
        addNewRT: "הוסף ראשי תיבות חדשים לרשימה הקיימת",
        addSingleWord: "ניתן להוסיף מילה חילופית בודדת בלבד",
      },
      searchIn: {
        allBooks: "רשימה מלאה - כל הספרים",
        all: "בכל הספרים",
        selected: "במסומנים בלבד",
        in: "רשימת מפרשים נוכחית",
        browse: "עיין...",
        current: "ברשימה נוכחית",
        siyun_maf: "בציונים ומפתחות",
        addSearchList: "הוסף רשימה",
      },
    },
    freeSearchErrors: {
      error1: "גלישת זכרון",
      error2: "תוים מיוחדים לא תקינים",
      error3: "חיפוש * מורחב מדי",
      error4: "חיפוש בציונים ומפתחות נתמך בגירסת התוכנה בלבד",
      error5: "תקלה בחיפוש",
      error6: "תקלה בחיפוש, אנא נסה שנית.",
      error7: "יש להפעיל את תוכנת אוצר החכמה הראשי על מנת לחפש",
    },
    freeSearchResults: {
      title: "סנן רשימה ל:",
      allResultsTitle: "בכל הספרים",
      recentSearches: "חיפושים אחרונים",
      stop: "עצור",
      sortBy: "מיין לפי:",
      reloadResults: "טוען תוצאות חיפוש חופשי",
      resltsSearchForWord: "תוצאות חיפוש למילים:",
      nameBookAndNumResults: "שם הספר:,מספר תוצאות:",
      resultsSearchForWord: "תוצאות חיפוש בתוכן הספרים: ",
      resultIn: "תוצאות ב",
      books: "ספרים",
      listSaved: "רשימה שמורה",
      inLimitedListBooks: "ברשימת ספרים מוגבלת",
      resulteTziun: "תוצאות חיפוש בציונים:",
      resulteKey: "תוצאות חיפוש במפתחות:",
    },
    recentOpenedBooks: {
      header: "ספרים שנפתחו",
      emptyList: "אין ספרים בהסטוריה",
    },
    fsresults: {
      header: "תוצאות חיפוש",
    },
    exportResults: {
      bookListResultsHeader: "רשימת ספרים",
      commentsList: "רשימת הערות",
      linksList: "רשימת קישורים",
      keysList: "רשימת מפתחות",
    },
    createBook: {
      titleWin: "עריכת ספר",
      wellcome: "ברוכים הבאים לחלון יצירת ועריכת ספרים משלך!",
      text1: " באפשרותך ליצור ספר חדש או לערוך ספר קיים",
      text2: "מה תרצה לעשות?",
      text3: "ספרים אחרונים שיצרת:",
      text4: "האם אתה בטוח שברצונך לצאת ללא שמירת הספר?",
      text5: "ישנו ספר פתוח, לשמור קודם את הספר הנוכחי?",
      exitNonSavedQ: "האם אתה בטוח שברצונך לצאת ללא שמירת הספר?",
      saveandclose: "שמור וסגור",
      learnMore: "למד עוד",
      createNew: "צור ספר חדש",
      editBook: "ערוך ספר קיים",
      deleteBook: "למחוק את הספר?",
      deletePages: "האם אתה בטוח שברצונך למחוק",
      detailesBook: "פרטי ספר",
      enterNameBook: "הכנס שם ספר",
      enterNameAuthorBook: "הכנס שם מחבר",
      text6: "בחר מהיכן להוסיף עמוד",
      text7: "מהאפשרויות המוצגות באזור העליון",
      addFromPage: "הוסף מעמוד:",
      currentPage: "עמוד נוכחי",
      startPage: "תחילת הספר",
      dontForgetSaved: " אל תשכח לשמור את",
      newBook: "הספר החדש! ",
      creatMineBook: "יצירת ספר אישי",
      errorSavedEmptyBook: "לא ניתן לשמור ספר ריק.",
      failedSavedBook: "שמירת הספר נכשלה",
      ExitAndLostAllChangQ: "לצאת ולאבד את כל השינויים?",
      convertImg: "מעבד לתמונה...",
    },
    quickBtn: {
      header: "צור כפתור מהיר חדש",
      placeholder: "קרא שם לכפתור המהיר החדש",
      btn: "צור",
      successAddMessage1: "כפתור מהיר  ",
      successAddMessage2: " נוסף בהצלחה",
      addBooks: "הוסף ספרים לכפתור מהיר",
      noBookInList: "אין ספרים ברשימה",
      allList: "לרשימה המלאה",
      showInBookList: "הצג ברשימה",
      noBtns: " אין כפתורים ברשימה. ",
      pressForAdd: "לחץ על הכפתור כדי להוסיף כפתור חדש",
      deleteQuickBtnNameQ: " האם אתה בטוח שברצונך למחוק כפתור מהיר בשם ",
      succeedDeleteQckBtn: "הכפתור מהיר נמחק בהצלחה",
    },
    tsiyunim: {
      header: "ציונים",
      header2: "ציונים לספרי יסוד",
      placeholder: "חפש בציונים",
      myheader: "הציונים שלי",
      myplaceholder: "חפש בציונים שלי",
      addTsiyunHeader: "הוסף ציון אישי חדש בעמוד",
      addplaceholder: "שם הציון",
      addBtn: "צור",
      addBtnNew: "+ צור חדש",
      successAddMessage1: "הציון ",
      successAddMessage2: " נוסף בהצלחה",
      noMine: "עוד לא נוצרו ציונים אישיים",
      toAddMine: "להוספת ציון אישי לחץ על",
      newMine: "'ציון אישי חדש",
      editTsiyun: "ערוך ציון",
      myTsiyun: "ציון אישי",
    },
    customShortcuts: {
      header: "צור קיצור דרך",
      placeholder: "הכנס תו עבור קיצור דרך",
      btn: "צור",
      successAddMessage1: "קיצור דרך  ",
      successAddMessage2: " נוצר בהצלחה",
      successfullyUpdated: " עודכן בהצלחה",
      successfullyDeleted: " נמחק בהצלחה",
      setShortcut: "צור קיצור דרך לספר זה",
      exists: "דריסת קיצור דרך קיים",
      replaceExistingShortcut:
        " קיצור דרך לתו זה כבר קיים, האם ברצונך להחליף אותו?",
      explanation: "הספר הנבחר ייפתח בלחיצה על Alt + ",
      menuHeader: "קיצורי מקלדת אישיים לפתיחת ספר",
      error: "שגיאה בעדכון קיצור דרך",
    },
    pages: {
      header: "עמודים",
      placeholder: "חפש בעמודים",
    },
    book: {
      outof: " מתוך",
      navigatorHeader: "סימניות ניווט בספר",
      saveBook: "שמור ספר",
      editOtherBook: "ערוך ספר אחר",
      importBook: "ייבא ספר קיים",
      bookPagesHeaders: "כותרות עמודי הספר",
      headers: "כותרות",
      showBookHeaders: "הצג את כותרות הספר",
      showBookMark: "הצג סימניה",
    },
    extensions: {
      title: "הרחבות",
      pdfName: "יבוא קבצי PDF קיימים וחדשים",
      stockName: "יבוא מאגרים אישיים",
      myPdfs: "קבצי ה PDF שלי",
      noSupportWarning1:
        "בקבצי PDF המועלים לתוכנה יתכנו בעיות הקשורות לפורמט ולמבנה הקובץ.",
      noSupportWarning2:
        "גם בקבצים פשוטים יתכנו בעיות בשל מבנה לא אחיד של הקובץ. ",
      noSupportWarning3: "לא תינתן תמיכה טכנית בכל הנוגע לכלי זה.",
    },
    changeBookInfo: {
      title: "כלים > שנה פרטי ספר",
      bookName: "שם ספר",
      authorName: "שם מחבר",
      yearName: "שנת הדפסה",
      placeName: "מקום הדפסה",
      chooseBook: "בחר ספר שתרצה לשנות את פרטיו",
      selectBook: "שנה פרטי ספר",
      addBooksName: "שמות נוספים לספר",
      addAuthorsName: "שמות נוספים למחבר",
      originalBk: "פרטי הספר המקוריים:",
      backToOriginalBk: "חזור לפרטי הספר המקוריים",
      change: "שנה",
      relevance: "רלוונטיות",
      deskResults: "מרחק תוצאות",
      numResults: "מספר תוצאות",
      orderDor: "סדר הדורות",
    },
    mainMenu: {
      removeMessage: "הסר הודעה",
      title: "תפריט",
      homePage: "דף הבית",
      onlineStore: "חנות מקוונת",
      support: "תמיכה",
      settingsName: "הגדרות",
      toolsName: "כלים",
      extensionsName: "הרחבות",
      helpName: "עזרה",
      contactName: "צור קשר",
      repoBugsName: "דיווח על באגים",
      otzarSite: "לאתר אוצר החכמה",
      helpFileName:
        location.protocol + "//" + location.host + "/static/help_he.pdf",
      helpFileNameElectron: globalThis.APP_URL_SHORT
        ? globalThis.APP_URL_SHORT + "/static/help_he.pdf"
        : "static/help_he.pdf",
      support: "תמיכה",
      myProfile: "פרופיל אישי",
      otzarStoreURL: "https://www.otzar.org/wotzar/pcionlinestore.aspx",
      managePage: "דף ניהול",
    },
    mainSettings: {
      title: "הגדרות",
      languageName: "הגדרות שפה",
      displaySttingName: "הגדרות תצוגה",
      Hyperlinks: "הגדרות מראי מקומות",
      backupSettingName: "גיבוי יומי אוטומטי",
      resetData: "איפוס נתונים",
      advSettings: "הגדרות מתקדמות",
      askFactoryData: "פעולה זאת תמחק את כל נתוני המשתמש. האם אתה בטוח?",
      booklist: "הגדרות רשימת ספרים",
    },
    advMenuSettings: {
      quailty: "איכות תמונה",
      hquailty: "גבוהה",
      mquailty: "בינונית",
      lquailty: "נמוכה",
      pdfZoom: "התאמת זום בספרי פידיאף",
      pdfMsg:
        "שים לב, ככל שאיכות התמונה גבוהה יותר, קצב הדפדוף עשוי להיות איטי יותר.",
    },
    myProfile: {
      myLicense: "הרשיון שלי",
      personalArea: "איזור אישי",
      savingPersonalData: "שמירת מידע אישי",
      logout: "התנתק",
      passwordChange: "שינוי סיסמא",
      createSubUser: "צור משתמש חדש",
      messageNoPackages: "אין ברשותך את החבילות הבאות:",
      messagePurchase: "באפשרותך לרוכשם כעת ולהוסיפם מיידית לתוכנה",
      toPurchase: "לרכישת חבילות",
      messageCanPurchase: "בחר את החבילות שברצונך להוסיף לתוכנה.",
      noMefLic: "אין לך רשיון למפרשי האוצר",
      toPurchaseMef: "לרכישת מפרשי האוצר",
      connectAsUser: "התחבר כמשתמש אחר",
      disconnectSettings: "הגדרות התנתקות",
      availableFromVersion: "זמין מגירסה %1% בלבד",
      upgrade: "עדכון",
      availableNow: " זמין לרכישה כעת. (את הדיסק יש לשלוח למשרד.)",
      toPurchase2: "לרכישה",
      autoAdd:
        "באפשרותך לרוכשם כאן והם יתווספו לדיסק באופן מיידי (ללא שינוע הדיסק למשרד).",
      purchaseUpgrade: "לרכישת עדכון",
      toPurchase3: "לרכישת עדכון או חבילות",
    },
    myLicense: {
      OH_license: "מנוי מקוון אוצר החכמה",
      MEF_license: "מנוי מקוון מפרשי האוצר",
      printLicense: "כרטיסיות הדפסה לאוצר החכמה",
      passwordChange: "שינוי סיסמא",
      edition: "מהדורה",
      period: "משך",
      packages: "חבילות מכונים",
      start: "תאריך התחלה",
      end: "תאריך סיום",
      amount: "כמות",
      prints: "הדפסות",
      noLic: "אין לך מנוי פעיל",
      youHaveViewTicket: "יש לך כרטיסיית צפייה",
      youHaveViewTickets: "יש לך כרטיסיות צפייה",
      youHaveLeft: "נותרו לך",
      actualizeDay: "מימוש יום",
      dayActualized: "כבר מימשת יום בכרטיסיה זו היום",
    },
    disconnectSettings: {
      disconnectAfter: "נתק משתמש לאחר",
      noUse: "דקות ללא שימוש באתר",
    },
    support: {
      waiting: "אנא המתן...",
      contactSupport: "נא צור קשר עם התמיכה:",
      openLogFile: "פתח קובץ שגיאות",
      noFileMsg: "קובץ שגיאות לא קיים",
      openTV: "פתח תוכנת חיבור מרחוק",
    },
    mainTools: {
      memSnapStart: "תהליך יצירת קובץ החל",
      memSnapEndSuccessful: "תהליך יצירת קובץ הסתיים בהצלחה",
      memSnapEndUnsuccessful: "התרחשה שגיאה ביצירת הקובץ",
      memSnap: "צור קובץ מידע זיכרון",
      title: "כלים",
      encyclopedia: "אנצקלופדיה תלמודית",
      createMineBook: "צור ספר משלך",
      historyName: "היסטוריה",
      personalExtensionsName: "תוספות אישיות",
      activeRepositoryName: "קבע מאגר פעיל",
      customPigeonsName: "מיונים מותאמים אישית",
      createCustomBook: "צור ספר משלך",
      desktopName: "שולחן עבודה",
      enableBackupName: "גיבוי",
      refreshListName: "רענון רשימה",
      updateCalender: "עדכון לוח שנה",
      keyboardOnScreen: "מקלדת וירטואלית",
      changeBookInfoName: "שנה פרטי ספר",
      active: "הפעל",
      refresh: "רענן",
      keys: "מפתחות",
      fileError: "קובץ לא תקין",
      succeedUpdateBoard: "לוח עודכן בהצלחה",
      desktopPath: "כלים > שולחן עבודה",
      saveDesktop: "שמור שולחן עבודה",
      openDesktop: "פתח שולחן עבודה",
      setDefaulteDesktop: "קבע שולחן עבודה כברירת מחדל",
      historyPath: "היסטוריה",
      openBookFromLink: "פתח ספר עם קישור",
      enterLink: "הכנס קישור לספר",
      incorrectLink: "הקישור אינו תקין",
    },
    personalExtensions: {
      title: "תוספות אישיות",
      titleHader: "תוספות אישיות",
      commentTitle: "הערות",
      commentIn: " הערות ב ",
      keyTitle: "מפתחות",
      keyIn: "מפתחות ב ",
      markerIn: "הדגשות ב",
      markerTitle: "הדגשות",
      LinksTitle: "קישורים פנימיים",
      noComments: "אין הערות לספר זה",
      linkIn: "קישורים ב ",
      noKeys: "אין מפתחות לספר זה",
      noMarkers: "אין הדגשות לספר זה",
      noLinks: "אין קישורים פנימיים לספר זה.",
      succeedComment: "",
      succeedKey: "",
      succeedMarker: "ההדגשה נוצרה בהצלחה!",
      okRemoveComment: "האם אתה בטוח שברצונך להסיר הערה זו?",
      okRemoveKey: "האם אתה בטוח שברצונך להסיר מפתח זה?",
      okRemoveMarker: "האם אתה בטוח שברצונך להסיר הדגשה זה?",
      okRemoveComments: "האם אתה בטוח שברצונך להסיר הערות אילו?",
      okRemoveKeys: "האם אתה בטוח שברצונך להסיר מפתחות אילו?",
      okRemoveMarkers: "האם אתה בטוח שברצונך להסיר הדגשות אילו?",
      succeedRemoveComment: "הערה נמחקה מרשימת הערות בספר.",
      succeedRemoveKey: "המפתח נמחק מרשימת המפתחות בספר",
      succeedRemoveMarker: "ההדגשה הוסר בהצלחה!",
      editOf: "עריכת",
      key: "מפתח",
      comment: "הערה",
      createDate: "תאריך יצירה",
      newKey: "מפתח חדש",
      newComment: "הערה חדשה",
      marker: "הדגשה",
      innerLink: "קישור פנימי",
    },
    backupSetting: {
      title: "כלים > גיבוי",
      driveBackupName: "גבה בתיקיית אוצר החכמה",
      localBackupName: "גבה במקום אחר",
      autoBackupOnName: "מופעל",
      autoBackupOffName: "כבוי",
      savePlace: "מיקום שמירת גיבוי",
      nowBackup: "הפעל",
      playNowBackup: "הפעל גיבוי עכשיו",
      backupProgressMsg: "מגבה $1 מתוך $2 קבצים...",
      selectPlace: "בחר מיקום",
      restore: "שחזר",
      restoeExistingBackup: "שחזר גיבוי קיים",
      lastRestore: "גיבוי אחרון:",
      notFind: "לא נמצא",
      restoreTo: "מגבה ל: ",
      succeededFinshedBackup: "הגיבוי הסתיים בהצלחה!",
      backupMessage: "תהליך גיבוי מידע אישי רץ ברקע",
      backupFailMessage: "תהליך הגיבוי נכשל",
    },
    restorBackup: {
      title: "הנך עומד לשחזר נתונים מתוך קובץ גיבוי.",
      warning:
        "  אזהרה! הנתונים מתוך קובץ הגיבוי יחליפו את כל הנתונים הקיימים בתכנה כעת.",
      setDefulte:
        "כברירת מחדל נטען קובץ הגיבוי העדכני ביותר מתוך התיקיה שהגדרת כתיקיית גיבוי.",
      fileBackup: "קובץ הגיבוי",
      notFindBackupFind: "לא נמצא קובץ גיבוי במיקום זה",
      uploadOtherFile: "טען קובץ אחר",
      createInDate: "נוצר בתאריך: ",
      restorData: "שחזר נתונים",
      restorFromFile: "משחזר...מקובץ",
      succeedFinshedRestore: "השחזור הסתיים בהצלחה!",
      reloadSoftwear: "טען את התכנה מחדש",
      failedRestoreNotFindFile: "השחזור נכשל. הקובץ לא נמצא.",
      failRestore: "השחזור נכשל",
      checkBackupFile: "בודק תקינות קובץ גיבוי...",
      restorDB: "משחזר מסד נתונים... טבלה: ",
      restoreUserFile: "משחזר קבצי משתמש...",
      sumRestorinfFiles: "משחזר... $1 קבצים או תיקיות",
    },
    encyclopedia: {
      titleWin: "מפתח ערכים לאנציקלופדיה תלמודית",
      freeSearch: "חיפוש חופשי בתוכן האנציקלופדיה",
      mainValue: "ערכים ראשיים",
      subValue: "ערכים משניים",
      filterBy: "סנן לפי",
      all: "הכל",
      valuesSearch: "חיפוש ערכים באנציקלופדיה",
    },
    updates: {
      download: "מוריד עדכונים",
      updatesAvailable: "עדכון תוכנה %VER% זמין להורדה כעת.",
      updatesAvailableMsg:
        "העדכון יורד ברקע. להחלת העדכון יש להפעיל את התוכנה בסיום.",
      downloadNow: "עדכן כעת",
      noDownloadNow: "לא עכשיו",
      downloading: "מוריד עדכון %VER%",
      extracting: "מחלץ עדכון %VER%",
      copyingToDrive: "מסנכרן קבצים לדיסק",
      copyingToLocal: "מסנכרן תוכנה",
      restartMsg: "תהליך העדכון הסתיים",
      restart: "אתחל תוכנה והחל עדכונים",
      restartLater: "לא עכשיו",
      errorMsg: "אירעה שגיאה במהלך העדכון",
      appUpdates: "עדכוני תוכנה",
      whatsNew: "מה חדש בעדכון?",
      appUpdated: "התוכנה מעודכנת!",
      update: "עדכון",
      showLogFile: "פתח לוג עדכון אחרון",
      externalDriveWarning:
        "הדיסק החיצוני אינו מחובר. על מנת לעדכן גם אותו, יש לחברו ולהפעיל את התוכנה מחדש.",
      downloadNowCurrentDisk: "עדכן דיסק נוכחי בלבד",
      downloadNowAllDisks: "עדכן את כל הדיסקים המחוברים",
      multiDisksFound: "נמצאו כמה דיסקים מחוברים",
      disklocalMismatch:
        "התוכנה המותקנת אינה תואמת לתוכנה שבדיסק. התוכנה תסגר כעת.",
      runFromMainApp: "הגירסה המותקנה הינה ישנה. יש להפעיל את התוכנה שבדיסק",
    },
    mainHelp: {
      name: "עזרה",
      downloadPDF: "הורד קבצי הדרכה בפורמט PDF",
      trainningSite: "לאתר ההדרכה",
    },

    showHelp: {
      name: "הצג עזרה",
    },
    licenseCode: {
      name: "עדכון רשיון",
      enterCode: "הכנס קוד לעדכון רשיון:",
      update: "עדכן",
    },
    comment: {
      placeholder: "חפש בהערות",
    },
    key: {
      placeholder: "מפתחות",
    },
    marker: {
      placeholder: "הדגשות",
    },
    bookDetails: {
      header: "פרטי הספר",
      bookName: "שם הספר",
      bookAuthor: "שם מחבר",
      bookPlace: "מקום הדפסה",
      bookYear: "שנת הדפסה",
      subjects: "נושאים",
      bookId: "מספר הספר",
      addNames: "שמות נוספים",
      addAuthors: "מחברים נוספים",
    },
    bibDetails: {
      title: "מפעל הביביליוגרפיה",
      addAuthors: "אישים נוספים",
      collection: "אוסף",
      publisher: "דפוס",
      bibId: "מספר קטלוגי",
      prevPub: "הוצאה קודמת",
      hebHeaderCon: "המשך כותר עברי",
      engHeaderCon: "המשך כותר לועזי",
      cerifications: "הסכמות",
      comments: "הערות",
      bookName: "כותר",
      bookName2: "כותר אחיד נוסף",
      preHeader: "כותר מקדים",
      bookHeader3: "כותר נוסף",
      publisher2: "מדפיס נוסף",
      edition: "מהדורה",
      addMul: "מול נוסף",
      mul: "מוציא לאור",
      author: "מחבר",
      addAuthor: "מחבר נוסף",
      place: "מקום ההוצאה",
      place1: "מקום ההוצאה אחיד",
      addPlace: "מקום נוסף",
      trans: "מתרגם",
      volumes: "סדרה",
      alpi: "על-פי",
      year: "פרט השנה",
      engYear: "שנת פרסום אזרחית",
      hebYear: "שנת פרסום עברית",
      lang: "שפה",
      taagid: "תאגיד נוסף",
      description: "תאורת",
    },
    leumiDetails: {
      title: "הספריה הלאומית",
      author: "מחבר",
      addAuthors: "מחברים נוספים",
      bookName: "כותר",
      bookName2: "המשך כותר",
      catId: "מספר מערכת",
      hekef: "היקף החומר",
      pubPlace: "מקום הדפסה",
      pubYear: "שנת הדפסה",
      subjects: "נושאים",
    },
    bookPrint: {
      printer: "מדפסת",
      printBackground: "תהליך הדפסה רץ ברקע",
      layout: "פריסה",
      copies: "עותקים",
      header: "הדפסה",
      printRang: "טווח הדפסה",
      from: "מעמוד",
      to: "עד עמוד",
      btnTxt: "הדפסה",
      currentPage: "עמוד נוכחי",
      note1: "(אנו ממליצים לייצא רק עד 100 עמודים בבבת אחת)",
      note2: "ברשותך כרטיסיית הדפסה מס 123456",
      titleTopPage: "כותרת עליונה לדף",
      topTitlePlaceHolder: "כותרת עליונה",
      comment: "הערות",
      contentComment: "כלול בהדפסה הערות אישיות על הספר",
      cancel: "ביטול",
      export: "יוצר קובץ, אנא המתן...",
      prepare: "מכין תמונות",
      printBy: 'הודפס ע"י תוכנת אוצר החכמה',
      printByWeb: "הודפס מאתר אוצר החכמה",
      noPrintMsg: "ספר זה אינו מורשה להדפסה",
      exportActionStop: "פעולת היצוא בעצירה",
      printByOtzar: "הודפס מאוצר החכמה",
      PDFLimited: "הדפסה לPDF מוגבלת ל%NUM% עמודים",
      FsPDFLimited: "מוגבל ל%NUM% עמודים בכל ספר",
      maxToOnline: "לא ניתן להדפיס יותר מ%NUM% עמודים",
      popupWarnTitle: "הדפדפן שלך מוגדר לחסום חלונות-קופצים",
      popupWarnTxt1:
        "כדי להשלים את פעולת ההדפסה, לחץ על האייקון עם האיקס האדום בסוף שורת הכתובת ולחץ על הקישור.",
      popupWarnTxt2:
        "כדי שהבעיה לא תישנה, ממולץ לבחור ב 'התרה תמיד של חלונות קופצים והפניות אוטומטיות מאתר זה.'",
      printCodeMsg: "ברשותך כרטיסית הדפסה מספר ",
      pagesLeft: "יתרתך:",
      allowedPrintsMsg:
        "מספר העמודים שהינך מורשה להדפיס היום מספר זה ללא שימוש בכרטיסיית הדפסה הוא: ",
      allowedPrintsUnLimited:
        "מספר העמודים שהינך מורשה להדפיס ברצף ללא שימוש בכרטיסיית הדפסה הוא: ",
      usePrintCodeMsg: "תוכל להדפיס עמודים נוספים על ידי שימוש בכרטיסית הדפסה",
      inputPrintCode: "הזן מספר כרטיסיה",
      showPagesLeft: "החל",
      purchasePrintCode: "רכישת הדפסה",
      printOverflow: "חרגת ממספר העמודים המורשים לך להדפסה",
      startFromHere: "התחל הדפסה בעמוד זה",
      endHere: "סיים הדפסה בעמוד זה",
      smallFile: "צור קובץ PDF קטן יותר (איטי יותר)",
      purchaseTicket: "לרכישת כרטיסייה",
      purchaseAnotherTicket: "לרכישת כרטיסייה נוספת",
      printTicket: "כרטיסיית הדפסה",
      left: "יתרה",
      errorPrinting: "תקלה בהדפסה ",
      printLic: "הרשאות הדפסה לספר זה",
      noLimit: "לבעלי זכות צפייה אין הגבלה על הדפסת דף בודד.",
      allowedMsg:
        " מספר הדפים שהינך מורשה להדפיס ברצף כמנוי הוא 20 דפים בלבד    (לכל יום מנוי)",
      allowedPrintsMosad: "מספר הדפים שהינך מורשה להדפיס ברצף: ",
      dailyCredit: "יתרתך להיום: ",
      pages: " דפים",
      untill: "עד",
      alreadyPrinted:
        "עמודים שכבר הדפסת בשבוע האחרון, ניתן להדפיסם שוב ללא תשלום.",
      dailyLic: "דפים למנוי יומי",
      downloading: "מוריד קובץ",
      limitMsg: "בספר זה ניתן להדפיס עד %1% עמודים בכל פעם",
      markers: "הדגשות",
      contentMarker: "כלול בהדפסה הדגשות אישיות על הספר",
    },
    bookSelectArea: {
      header: "אפשרויות סימון קטע",
      btnCopyImg: "שמור תמונה בשם",
      btnCopyImgCB: "העתק תמונה",
      btnCrtMarker: "צור הדגשה",
      btnMarker: "צור הדגשה",
      btnCopyTxt: "העתק טקסט",
      copyImgMsg: "התמונה הועתקה ללוח",
      copyTxtMsg:
        "טקסט נבחר הועתק ללוח,\r\n באפשרותך להדביקו בכל תוכנת  עריכת טקסט",
      searchInBook: "חפש בספר נוכחי",
    },
    link: {
      message: "קישור לספר הועתק בהצלחה ללוח",
    },
    users: {
      noSavePersonalData:
        "משתמש זה אינו יכול לשמור מידע אישי.<br>ניתן ליצור משתמש עבור מידע פרטי בפרופיל האישי",
    },
    loader: {
      slowLoad: "זמן הטעינה עלול להמשך למעלה מהרגיל. אנא המתן בסבלנות.",
      userSettings: "טוען הגדרות משתמש",
      applyUpdates: "מחיל עדכונים",
      appinfo: "טוען מידע תוכנה",
      altWords: "טוען מילים חילופיות",
      quickBtn: "טוען כפתורים מהירים",
      userAdds: "טוען תוספות אישיות",
      searchHistory: "טוען הסטוריית חיפוש",
      books: "טוען ספרים",
      systemFolders: "טוען תיקיות מערכת",
      yesodInx: "טוען אינדקסים של ספרי יסוד",
      userFolder: "טוען תיקיות משתמש",
      favBooks: "טוען ספרים מועדפים",
      lastBooks: "טוען ספרים אחרונים שנפתחו",
      done: "טוען תוכנה",
      customSortB: "טוען מיונים מותאמים אישית",
      autoBackup: "מגבה נתונים",
      socketConnected: "בדיקת חיבור",
      network_server: "מאתר שרת",
      licencecheck: "מאמת נתונים",
      delbooks: "טוען שינויים",
      upgradingDB:
        "עדכון גירסה חדשה. תהליך זה עשוי לארוך מספר דקות... בסיום התהליך התוכנה תופעל מחדש",
      upgradingMefoDB:
        "מעדכן טבלאות מפרשי האוצר. אנא המתן בסבלנות. בסיום התהליך התוכנה תופעל מחדש",
      updateError: "שגיאה במהלך עדכון הנתונים. פנה לתמיכה ",
    },
    setting: {
      settingListBook: "הגדרות רשימות ספרים",
      settingListFree: "הגדרות רשימת תוצאות חיפוש",
      titleHeightGzirim: "גובה גזירים ברשימה",
      titleFSResultsTrans: "סימון תוצאות חיפוש בתוכן הספרים",
      titleShowSdarot: "אופן הצגת סדרות ספרים",
      openSdarot: "סדרות ספרים פתוחות",
      closeSdarot: "סדרות ספרים סגורות",
      gzirinLow: "נמוך",
      gzirinMedium: "בינוני",
      gzirinHigh: "גבוה",
      titleSortList: "אופן מיון רשימות הספרים",
      mouseWheelMethod: "שימוש בגלגלת העכבר",
      bookByBook: "מעבר בין הספרים",
      quickScroll: "גלילה מהירה",
      ocrSelectionDefault: "סימון קטע בספר",
      on: "קבע כברירת מחדל",
      off: "בלחיצה על הסמל",
      sdarotMode: "הצגת כרכים",
      onlySdarot: "הצג כרכים בלבד",
      openBook: " פתח ספר בהצגת כרכים",
      fullScreen: "אפשרויות מסך מלא",
      hideRightBar: "הסתר חלונית עמודים וציונים",
      hideSearchBar: "הסתר שורת חיפוש בספר",
      hideTopHeader: "הסתר שורת כפתורים מהירים",
      hideAppHeader: "הסתר את כותרת התוכנה",
      hideBottomStatusBar: "הסתר שורת משימות תחתונה",
      showAdvancedSettings: "הצג הגדרות מתקדמות",
      hideAdvancedSettings: "הסתר הגדרות מתקדמות",
      imageQuality: "איכות תמונת הספר",
      option1: "אפשרות 1",
      option2: "אפשרות 2",
      advancedSettings: "הגדרות מתקדמות",
      pagePreview: "תצוגה מקדימה לעמוד",
      previewSize: "גודל התצוגה",
      big: "גדול",
      medium: "בינוני",
      small: "קטן",
      fullPage: "עמוד מלא",
      headers: "כותרות",
      previewType: "סוג התצוגה",
      virtualKeyboard: "הצג איקון לפתיחת מקלדת בתוך כל שדות הטקסט",
      virtualKeyboardTitle: "מקלדת וירטואלית",
      pagesPanelTitle: "ציוני העמודים",
      pagesPanel: "הצג את ציוני העמודים לצד תצוגת הספר",
      Accessibility: "נגישות",
    },

    advancSearchBook: {
      nameBook: "שם ספר",
      author: "מחבר",
      book: "ספר",
      year: "שנה",
      place: "מקום",
      yearPrint: "שנת הדפסה (או טווח שנים xxxx-yyyy)",
      yearPrint2: " ",
      placePrint: "מקום הדפסה",
      text1: " ציין      את הפרטים המבוקשים בכל השדות או בחלק מהם",
      text2: "חיפוש מתקדם לפרטי הספר",
      year: "שנת הדפסה",
      dorot: "סדר הדורות",
    },
    customSort: {
      titleHeader:
        "גרור את הפריטים הרצוים מרשימת קבצי מערכת או קבצים אשיים ושחרר אותם ברשימה. כדי לשנות סדר גרור ברשימה עצמה.",
      listSort: "רשימת מיונים",
      default: "ברירת מחדל",
      addNewSort: "הכנס מיון חדש",
      setDefault: "קבע ברירת מחדל",
      resetDefault: "שחזר ברירת מחדל",
      cancelDefault: "בטל ברירת מחדל",
      emptyListSortFile: "אין קבצים למיון זה.",
      text: "כדי להוסיף קבצים למיון גרור קבצים מרשימות הקבצים",
      saveChange: "האם אתה רוצה לשמור שינויים?",
      successSave: "השינויים נשמרו בהצלחה!",
      deleteSort: "האם אתה בטוח שברצונך להסיר מיון זה מרשימת המיונים?",
      successDelete: "המיון הוסר בהצלחה!",
      theSort: "המיון",
      successAdded: "התווסף בהצלחה",
      order: "סדר",
      moveFirst: "העבר לראש הרשימה",
      moveUp: "העבר למעלה",
      moveDown: "העבר למטה",
      moveLast: "העבר לסוף הרשימה",
      readOnly: "לקריאה בלבד!",
      nameSort: "שם המיון: ",
      customSort: "מיונים מותאמים אישית",
      mineFolderAndFile: "תיקיות וקבצים אישיים",
      systemFolderAndFile: "תיקיות וקבצי מערכת",
      defaultSort: "מיון ברירת מחדל",
      succedSelected: "נבחר בהצלחה! ",
    },
    links1: {
      enterDesc: "הכנס תאור לקישור",
      desc1:
        "כדי לקבוע את העמוד המקושר עליך לפתוח את הספר או העמוד הרצוי וללחוץ במקום המתאים.",
      goPage: "עבור לעמוד",
      notCreatCurrentPage: "לא ניתן ליצור קישור באותו עמוד",
      successCreateMarker: "ההדגשה נוצרה בהצלחה!",
      deleteLinkQck: "למחוק את הקישור?",
      deleteLinkQcks: "למחוק את הקישורים?",
      successDeleteLink: "הקישור נמחק בהצלחה!",
    },
    backup1: {
      notSuccessLoad: "לא הצליח לטעון מיקום ברירת מחדל של קובץ גיבוי",
      autoBackupToHouer: "גיבוי אוטומטי הוגדר. לשעה",
    },
    login1: {
      createUserSuccess: "משתמש נוצר בהצלחה - לאחר האישור תועבר לדף ההתחברות",
      tryOtherName: "קיים משתמש עם שם כזה - נסה שם אחר",
      errorCreateUser: "אירעה שגיאה ביצירת המשתמש",
    },
    itemBook1: {
      edit: "ערוך ספר",
      addSuccessBook: "נוספה בהצלחה לספר!",
      addSuccessBook1: "נוסף בהצלחה לספר!",
      editNameAuthor: "ערוך שם מחבר",
      deleteAuthor: "מחק מחבר",
      selectFont: "בחר פונט:",
      selectSizeText: "בחר גודל טקסט:",
      openNewWindow: " פתח ספר בחלון",
    },
    files1: {
      numFileFolder: "מספר קבצים בתיקיה:",
      propertiesFolder: "מאפייני תיקיה",
      fullNameFolder: "שם תיקיה מלא:",
      dateCreateFolder: "תאריך יצירה:",
      typeFolder: "סוג תיקיה:",
      placeFolder: "מיקום תיקיה",
      file: "קובץ",
      place: "מיקום",
      selectFile: "קובץ שנבחר",
      selectFolder: "תיקיה שנבחרה",
      noSelectFolder: "לא נבחרה תיקיה",
      noSelectFile: "לא נבחר קובץ",
      noResults: "אין תוצאות לחיפוש זה",
      emptyFolder: "תיקיה זו ריקה",
      noFindSystemFolder: "לא נמצאו תיקיות וקבצי מערכת!",
      mainFolder: "תיקיה ראשית",
      newFolder: "תיקיה חדשה",
      hiddenBooks: "ספרים מוסתרים",
      mainBook: "ספרים אישיים",
      inMainFile: "מתוך: קבצים אישיים",
      inSystemFile: "מתוך: קבצי מערכת ",
    },
    desktop: {
      desktop: "שולחן עבודה",
    },
    qckbtn1: {
      fileToQckBtn: " ספרים לכפתור מהיר בשם: ",
      maxLst: "לא ניתן להוסיף מעל 250 ספרים לכפתור מהיר",
    },
    createBook1: {
      createSuccess: "הספר נוצר בהצלחה!",
      saveSuccessed: "הספר נשמר בהצלחה!",
      failSavedImg: "שמירת התמונות נכשלה",
      faileSaveBook: "שמירת הספר נכשלה",
      createNewBook: "צור ספר חדש",
      backMainScreen: "חזור למסך הראשי",
      openExistingBook: "פתח ספר קיים",
      editDetailesBook: "ערוך פרטי ספר",
      closeBook: "סגור ספר",
      includResultsSearch: "כלול תוצאות חיפוש",
      includResults: "כלול תוצאות",
      notSelectCurrentPage: "לא נבחר עמוד נוכחי",
      fromPage: "מעמוד ...",
      cutArea: "גזור קטע",
      clickOnBtnOcr: " לחץ על הכפתור כדי לגזור קטע",
      clickRecBottomForSelect: "לחץ על הריבועים למטה כדי לבחור טקסט",
      clickImgBottomForSelect: " התמונה שברצונך להוסיף כאן.",
      cutOtherArea: "גזור קטע אחר",
      noViewBook: "אין ספר מוצג",
      textOr: "טקסט או",
      imgOr: "תמונה או",
      fileFromComputer: "קובץ מהמחשב",
      okAddinPage: "2. אשר הוספת עמוד",
      imgClipBoard: "תמונה מהלוח",
      copyPaste: "העתק - הדבק",
      copyTextOrImg: " העתק טקסט או תמונה",
      fromOtherPlace: "ממיקום כלשהוא והדבק כאן",
      pasteHere: "הדבק לכאן",
      pasteAgin: "הדבק שוב",
      loadFile: "טוען קובץ... ",
      saveBeforeClose: "לשמור לפני הסגירה?",
      noSelectCurrentPage: "לא נבחר עמוד נוכחי.",
      errorFile: "קובץ שגוי",
      errorAcsses: " בעית הרשאת גישה ללוח",
      errorAcssesMsg1:
        "  הגדרות הדפדפן שלך לא מאפשרות גישה ללוח ההעתקות. בדפדפן כרום תוכל לשנות את זה בשני דרכים:",
      errorAcssesMsg2:
        "בקצה שורת הכתובת מופיע סמליל של לוח, עם איקס אדום שמסמן שאין הרשאה:",
      errorAcssesMsg3: '  יש ללחוץ על הסמליל, ולבחור "אפשר תמיד לגשת ללוח"',
      errorAcssesMsg4:
        "לגשת להגדרות כרום על ידי העתקת הקישור הבא לשורת הכתובת:",
      errorAcssesMsg5: "ולהוסיף את כתובת האתר לרשימת האתרים המורשים.",
      editNameAuthor: "ערוך שם מחבר",
      deleteAuthor: "מחק חבר",
      notExistAuthor2: "המחבר שהזנת לא קיים ברשימת המחברים. להוסיף?",
      notExistAuthor: "מחבר לא קיים",
      choosAuthor: "ברצוני לבחור מחבר",
      faileDeleteBook: "מחיקת הספר נכשלה",
      succeedDeleteBook: "הספר נמחק בהצלחה!",
      noDetailes: "חלק מהפרטים חסרים",
      succeedAddedAuthor: "מחבר נוסף בהצלחה!",
      succeededDeleteAuthor: "המחבר נמחק בהצלחה!",
      succeededChangeNameAuthor: "שם המחבר שונה בהצלחה!",
      enterNameBook: "נא הכנס שם ספר",
      numPage: " עמוד מספר",
      page: "עד עמוד",
      currentPage: "עמוד נוכחי",
      optionEditWindow: "אפשרויות חלון עריכת ספר",
      selectArea: "קטע מסומן",
      inCurrentBook: "בספר נוכחי",
      notShowAgin: "אל תציג הודעה זו שוב",
      whatNext: "ומה הלאה? ",
      createMineBook: "צור ספר משלך",
      start: "בוא נתחיל ",
      next: "המשך >",
      knowHow: "רוצה לדעת איך?",
      enterMoreDetailes: "הזן פרטים נוספים לפני שאתה שומר את הספר...",
      setNameForNewBook: "תן שם לספר החדש:",
      addAuthor: "הוסף מחבר",
      screenMsg1: " באפשרותך ליצור ספר חדש",
      screenMsg2: "המורכב מדפים מתוך מאגר אוצר החכמה",
      screenMsg3: "או מקבצים ומתמונות מתוך  מחשבך האישי",
      screenMsg4: "את הספר שיצרת תוכל להוסיף",
      screenMsg5: "לרשימת הספרים בתוכנה",
      screen1Msg1: " תצוגת",
      screen1Msg2: "עמוד נוכחי",
      screen2Msg1: " 3. לאחר שהוספת את העמודים",
      screen2Msg2: "הרצויים לספר שלך",
      screen2Msg3:
        " תוכל לארגן ולסדר את הדפים בקלות על ידי גרירתם למקומם הרצוי .בחלונית תצוגת העמודים",
      selectWhereAddToBook: "1. בחר מהיכן להוסיף עמוד לספר שאתה יוצר:",
    },
    hideBookQuestion: "האם אתה בטוח שברצנוך להסתיר ספרים אלו?",
    hideBookQuestionSingle: "האם אתה בטוח שברצונך להסתיר ספר זה?",
    hideBookSuccess: "הספרים הוסתרו בהצלחה",
    hideBookSuccessSingle: "הספר הוסתר בהצלחה",
    resetHideBook: "ספרים מוסתרים אופסו בהצלחה",
    update: {
      clickHere: "קיים עדכון לחץ כאן",
    },
    advFreeSearch1: {
      saveMyAlt: "שמור",
      deleteMyAlt: "הסר",
    },
    wellcome1: {
      day: "יום",
      dafYumi: "דף היומי:",
      parashat: "פרשת  ",
      holyday: "חג",
      candleLight: " כניסת שבת",
      sabbatEnd: " יציאת שבת",
      Dawn: " עלות השחר",
      sunrise: "הנץ החמה",
      midnight: "חצות",
      sunset: "שקיעה",
      risingStar: "צאת הכוכבים",
      mefDesc: "הכירו את המיזם החדש מבית 'אוצר החכמה'!",
      mefDesc1: 'בחירת קטע מתוך דף הגמרא (גמרא / רש"י / תוספות)',
      mefDesc2: " תציג את רשימת כל המפרשים אודותיו!",
      forum: "פורום",
      forum1: "פורום",
      otzar: "אוצר החכמה",
      setting: "הגדרות",
      view: "תצוגה",
      help: "עזרה",
      loach: "לוח שנה",
      itim: "עיתים לבינה",
      contact1: "צור ",
      contact2: "קשר",
      desctop1: "שולחנות",
      desctop2: "עבודה",
      lastBookOpen: "ספרים אחרונים שפתחתי",
      sub: "נושאים",
      listBooks: "רשימות ספרים",
      text1: "המקוטלגות לפי נושאים שונים",
      text2: "פתח תיקית נושאים",
      text3: "מפרשים",
      text4: 'ספרי מפרשים על פרשיות התורה, ש"ס בבלי וירושלמי, משנה,',
      text5: 'רמב"ם, ועל השולחן ערוך',
      text6: "פתח תיקית מפרשים",
      text7: "הדף היומי",
      text8: "ספרים ומפרשים על",
      text9: "פתח רשימת ספרים",
      text10: "פרשת השבוע",
      text11: "ספרים ומפרשים על פרשת",
      text12: "רשימות ספרים",
      text13: "אחרונים שנפתחו",
      text14: "ספרים אקראיים",
      text15: "רשימת ספרים אקראיים",
      text16: "פתח רשימה",
      text17: "ספרים מועדפים",
      text18: "אין ספרים ברשימה",
      text19: "לחץ על הכוכב כדי להוסיף לרשימת המועדפים",
      text20: "לחץ על הכוכב כדי להוסיף לרשימת המועדפים",
      text21: "אנציקלופדיה תלמודית",
      text22: "מבית יד הרב הרצוג",
    },
    book1: {
      noDataOnBook: "חסרים נתונים לטעינת ספר זה ",
      notExistBook: "ספר לא קיים",
      enterNumBook: "הכנס מספר ספר",
    },
    service: {
      updateListBook: "עדכון רשימת ספרים",
    },
    errors: {
      mustInsertNameDesktop: "חובה להקליד שם שולחן עבודה",
      notExistData: "לא קיימים נתונים בשולחן עבודה הנוכחי לשמירה",
      code: "קוד שגיאה",
      errorMsg: "אופס,",
      errorMsg2: "משהו פה השתבש...",
      contactSupport: "פנה לתמיכה: 02-5866078 | או במייל: otzar@otzar.biz",
      userError: "תקלה ביצירת המשתמש",
      reloadPage: "טען את הדף מחדש",
      fatalError: "אירעה שגיאה בעליית התכנה, פנה לתמיכה.",
    },
    hiddenbooks: {
      name: "ספרים מוסתרים",
      menuTitle: "הגדרות > ספרים מוסתרים",
      showList: " פתח את רשימת הספרים המוסתרים",
      enable: "הפעל הסתרת ספרים",
      reset: "הפוך ספרים מוסתרים לגלויים",
      sureCancelHiddenBooks: "האם אתה בטוח שברצונך לבטל הסתרת ספרים אילו?",
      sureCancelHiddenBook: "האם אתה בטוח שברצונך לבטל הסתרת ספר זה?",
      succeedCancel: "ביטול הסתרה בוצע בהצלחה",
      nohiddenbooks: "אין ספרים מוסתרים",
      norecentbooks: "אין ספרים אחרונים",
    },
    extens1: {
      toAdd: "להוספת",
      key: "להוספת מפתח חדש",
      comment: "להוספת הערה חדשה",
      marker: "להוספת הדגשה חדשה",
      link: "להוספת לינק פנימי חדש",
      links: "להוספת לינק פנימי חדש",
      nothing: "",
    },
    about: {
      notFindInfo: "לא נמצא מידע על התוכנה",
      permanentLicense: "רשיון קבוע",
      temporaryLicense: " רשיון זמני, בתוקף עד",
      version: "גרסה",
      licensePackagesFull: "מלא",
      name: "המוצרים שלי / רכישת חבילות",
      package: "חבילות",
      characters: "תווים",
      refreshNow: "ריענון רשימה יתבצע כעת.",
      succedUpdateLicens: "רשיון עודכן בהצלחה.",
      errorUpdate: "תקלה בעדכון הרשיון, אנא פנה לתמיכה",
      edition: "מהדורה",
      nopackage: "ללא חבילות נוספות",
      userId: "מספר לקוח",
      updateversion: "גירסת עדכון",
      verMeforshei: "מפרשי האוצר גירסה",
      whatsNew: "מה חדש בעדכון האחרון?",
      whatsNewIn: "מה חדש בגירסה",
      noData: "אין מידע זמין",
    },
    reportingBugs: {
      nameclient: "שם לקוח",
      phone: "טלפון",
      email: "אימייל",
    },
    listBooks: {
      lastListBooks: "רשימות אחרונות",
      dontPinMoreFiveList: "לא ניתן לנעוץ יותר מ5 רשימות",
      selectedList: "רשימות נבחרות: ",
      openNewTab: "פתח בטאב חדש",
      openNewWindow: "פתח בחלון חדש",
    },
    tabs: {
      openNewTab: "פתח ספר חדש",
      duplicate: "שכפל",
      moveLeft: "הזז שמאלה",
      moveRight: "הזז ימינה",
      closeTabe: "סגור טאב",
      pin: "נעץ טאב",
      closeAll: "סגור הכל",
      closeOthers: "סגור טאבים אחרים",
      openNewWindow: "פתח ספר בחלון",
      minimAll: "מזער הכל",
      openAll: "פתח הכל",
      chooseBook: "פתח ספר",
      newTab: "פתיחת ספר בכרטיסיה חדשה",
      openBookMsg: "חפש ספר ברשימת הספרים, או בחר מהרשימות למטה.",
      toTab: "הפוך לטאב",
      overflowTabsMsg:
        "לא ניתן לפתוח יותר כרטיסיות , עליך לסגור כרטיסיות על מנת לפתוח ספרים חדשים",
      overflowWinsMsg:
        "לא ניתן לפתוח יותר ספרים בחלונות, עליך לסגור חלונות על מנת לפתוח ספרים נוספים",
      closeNotPinned: "סגור לא נעוצים",
      overideFirstTab: "סגור כרטיסיה ישנה",
      crtquikbtnFromTabs: "צור כפתור מהיר מטאבים פתוחים",
      crtquikbtnFromWins: "צור כפתור מהיר מחלונות פתוחים",
      nextSearchResults: "לתוצאות הבאות",
      prevSearchResults: "לתוצאות הקודמות",
    },
    driverErrors: {
      noPlace: "לא נשאר מקום פנוי בשרת",
      licenseInvalid: "רשיון לא תקין",
      licenceExpired: "תוקף הרשיון פג, יש לפנות לתמיכה לקבלת קוד",
      licenseUpdateError: "תקלה בעדכון הרשיון",
      generalError: "תקלה כללית",
      bookError: "תקלה בפתיחת הספר",
      pageError: "תקלה בעמוד",
      noPackage: "אין לך רשיון עבור ספר זה",
      ocrError: "תקלה בפיענוח הטקסט",
      licWarning: "הרשיון שלך עומד לפוג בתאריך ",
      checkOnKeyOrDisk:
        "אם ברשותך אוצר פנימי, נא ודא שחיברת את הדיסק און קי בצורה תקינה.",
      noDriver: ".מערכת ההגנה אינה מופעלת. פנה לתמיכה",
    },
    loadingPage: {
      titleScreen: "הספריה היהודית הממוחשבת",
      titleScreenPart2: "הגדולה בעולם",

      version: "גירסה",
      bookListRefresh: "עדכון רשימת הספרים",
      dataRefresh: "עדכון נתונים",
    },
    myPdf: {
      myPdfBook: "ספרי הPDF שלי",
      searchInPdfBook: "חפש בספרי PDF",
      nopdfbooks: "אין ספרי PDF אישיים",
    },
    optionNotAvailableInThisV: "אפשרות זאת לא זמינה בגרסה שברשותך",
    optionNotAvailableInDemoV: "אפשרות זאת לא זמינה בגרסת ההדגמה",
    optionNotAvailableForGuest: "אורח אינו מורשה לבצע פעולה זו",
    progressWindow: {
      exportPDFBookList: "יצוא רשימת ספרים לPDF",
      exportExcelBookList: "יצוא רשימת ספרים לEXCEL",
    },

    importData: {
      title: "ייבא נתונים מגרסאות קודמות",
      beforeStartMsg:
        " ראשית אנו רוצים לוודא היכן שמרת את הקבצים וההגדרות הישנות שלך.",
      installFolder: " תיקיית ההתקנה:",
      defaultPlace: "מיקום ברירת מחדל",
      defaultPlaces: "מיקומי ברירת מחדל",
      setOneFolder:
        "במידה ויש ברשותך ספרים אישיים או שולחנות עבודה ששמרת במיקומים אחרים  שאינם ברירת המחדל, עליך לרכזם בתיקיה אחת, ולהגדיר כאן את מיקומם:",
      moreFiles: "קבצים נוספים:",
      start: "התחל",
      startImpport: "התחל לייבא",
      viewImportLog: "הצג יומן ייבוא",
      reloadSoftwear: "אתחל תכנה להצגת הנתונים החדשים",
      importLog: "יומן ייבוא",
      saveLog: "שמור יומן",
      sendLog: "שלח את היומן לתמיכה",
      error: "שגיאה",
      errorUI_NoInstallFile:
        "שגיאה! תיקיית קבצי ההתקנה שלך אינה קיימת במיקום הבא. אנא פנה לתמיכה או נסה לבחור מיקום אחר.:",
      errorOF_PlaceMoreFiles:
        "שגיאה! תיקיית הקבצים הנוספים שלך אינה קיימת במיקום הבא:",
      starting: "מתחיל...",
      importingUserBooksChanges: "מייבא פרטי ספר ששונו...",
      importingUserBooksSearch: "מייבא היסטוריית חיפושי ספרים...",
      importingCusBooks: "מייבא ספרים אישיים...",
      importingUserFSaltword: "מייבא מילים חילופיות וראשי תיבות...",
      importFsHistiry: "מייבא היסטוריית חיפוש חופשי...",
      importMaagarim: "מייבא מאגרים...",
      importQuickBtn: "מייבא כפתורי גישה מהירה...",
      importRecentBooks: "מייבא רשימות ספרים אחרונים...",
      importRemovedAndHiddenBooks: "מייבא הגדרת ספרים שהוסרו או הוסתרו...",
      importSorts: "מייבא פרופילי חיפוש...",
      importTziunim: "מייבא ציונים...",
      importSavedDesktop: "מייבא שולחנות עבודה שמורים...",
      importUserExtens:
        "מייבא תוספות אישיות (סימניות, הערות, קישורים, מפתחות)...",
      zipOldFiles: "מגבה קבצים ישנים... הפעולה עשויה לקחת מספר דקות",
      successImporting: "הייבוא הסתיים:",
      errorImportingLog: "תקלה בייבוא נתונים - מצורף יומן ייבוא",
      welcomeImport:
        "ברוכים הבאים לאשף ייבוא הנתונים האישיים שלך מגרסאות קודמות.",
      welcomeMsg:
        " האשף תומך ביבוא מגרסה 14 ומעלה. אם יש ברשותך גרסה ישנה יותר, אנא פנה לתמיכה.",
      notFoundDefaulteFolder: "לא נמצאה תיקיית ברירת מחדל",
      changeLocation: "שנה מיקום",
      selectLocation: "בחר מיקום",
      successSavedLog: "היומן נשמר בהצלחה",
      failedSaveLog: "השמירה נכשלה",
      follderInstallOtzar: "התיקה בו הותקנה הגרסה הקודמת של אוצר החכמה",
      folderInstallData: "התיקה בה הותקנה הגרסה הקודמת של אוצר החכמה",
      diskOtzar: "דיסק אוצר החכמה",
      computer: "מחשב",
      findOtzarInstall:
        "מצאנו את אוצר החכמה מותקן על מחשבך ביותר ממיקום אחד. אנא בחר את המיקום המתאים:",
      selectOthorLocation: "בחר מיקום אחר",
      errorOUD_DontEXxists:
        "שגיאה! תיקיה לא קיימת: תיקיית הקבצים האישיים שלך (OTZAR_user_data) לא קיימת במיקום שהוגדר. אנא פנה לתמיכה או נסה לבחור מיקום אחר.",
      errorFolderDontFind:
        "שגיאה! תיקיה לא נמצאה: לא הצלחנו למצוא את מיקום תיקיית הקבצים האישיים שלך (OTZAR_user_data) במיקום המוגדר במערכת. אנא פנה לתמיכה או נסה לבחור מיקום ידנית:",
      timeMsg: "בהתאם לכמות החומר שברשותך, התהליך עשוי לקחת מספר דקות...",
    },
    hardReloadMessage: {
      message1: "רשימת הספרים מתרעננת ברקע.",
      message2: "בסיום התהליך ניידע אותך.",
    },
    editPdf: {
      title: "ערוך פרטי ספר",
      enterOrUpdate: "הכנס או עדכן פרטי הספר:",
      errorUpdate: "התרחשה שגיאה בעדכון פרטי הספר",
      succedUpdate: "בוצע בהצלחה עדכון רשימת ספרים יופעל מיד",
    },
    historyMenu: {
      deleteAllHistory: "ריקון היסטוריה",
      youSureToDeleteAll: "האם אתה בטוח שברצונך למחוק את כל ההסטוריה",
    },
    shortcutKeysMenu: {
      title: "מקשי קיצור במקלדת",
    },
    ocr: {
      notPossibleConvertOcr: "ספר זה אינו מורשה לפיענוח טקסט",
      selectArea: "סמן קטע",
    },
    actionSoftware: {
      preparListBook: "התוכנה מכינה את רשימת הספרים",
      finshedPreparedListBookClickForRefres:
        "הכנת רשימת הספרים הסתיימה.<br> לביצוע רענון לחץ על 'רענן'. ",
      finishRefreshListBook:
        "הכנת רשימת הספרים הסתיימה.  <br> לביצוע רענון לחץ על 'רענן'. ",
    },
    networkComputer: {
      connectError: "אופס משהו בחיבור לשרת לא תקין",
      connectAgain: "התחבר שוב",
      titleMenu: "מספר העמדות המקסימלי",
      titleMenuMef: "מספר העמדות המקסימלי למפרשי האוצר",
      itemMenu: "רשת",
      nameComputer: "שם מחשב:",
      connect: "מחובר:",
      returnServer: "חזור למצב שרת",
      noPlace: "לא נותר משתמש פנוי בשרת",
      noSrv: "לא נמצא שרת",
      contact_admin: "יש לפנות למנהל הרשת להמשך טיפול",
      back_to_srv: "חזור למצב שרת בלבד",
      onServer: "העמדה מופעלת כשרת בלבד",
      stillUsedQuestion: "האם העמדה זאת עדיין בשימוש",
      noSrvClose: "לא נמצא שרת - התוכנה תיסגר בקרוב",
      autoCloseOnAdminDisconnect:
        "העמדה נותקה על ידי מנהל הרשת - התוכנה תיסגר אוטומטית בקרוב",
      serverApp: "התוכנה מופעלת כשרת",
      maxStationsOH: "מספר עמדות מקסימאלי לאוצר החכמה",
      available: "פנויות לחיבור",
      maxStationsMEF: "מספר עמדות מקסימאלי למפרשי האוצר",
      compList: "רשימת מחשבים",
      disconnectMef: "נתק את מפרשי האוצר",
      serverAsStation: "השרת מתפקד גם כעמדה",
      turnOnAsStation: "הפעל את התוכנה גם במצב עמדה",
    },
    softwareNotUsed: {
      title: "התנתקות",
      msgBody:
        "שים לב, שמנו לב שהתוכנה לא בשימוש כבר במשך 20 דקות. בעוד כדקה התוכנה תתנתק אוטומטי",
      continue: "במידה והנך מעונין להמשיך",
      disconnectMsg: "נותקת מהאתר עקב חוסר שימוש",
      connectAgain: "התחבר שוב",
      disconnectMsgSingleUser: "התחברת ממחשב אחר",
    },
    shortcuts: {
      menuHeader: "קיצורי מקלדת קבועים",
      zoom: "זום",
      print: "הדפסה",
      space: "רווח",
      moveInPage: "מעבר בין חלקו העליון של הדף לתחתיתו",
      rightLeftArrows: "חיצים ימינה ושמאלה",
      navInPages: "מעבר בין הדפים",
      arrowsUpDown: "חיצים למעלה ולמטה",
      navResults: "ניווט בין תוצאות החיפוש",
      zoomPercent: "הקלדת אחוזי הזום",
      zoomOpen: "זום כשחלונית הזום פתוחה",
      fullScreen: "מסך מלא",
      exitFullScreen: "יציאה ממסך מלא",
      pinUnpinTab: "נעיצה וביטול נעיצה של ספר נוכחי",
      navTabs: "מעבר בין הספרים מימין לשמאל",
      navTabsToLeft: "מעבר בין הספרים משמאל לימין",
      inBookList: "ברשימת הספרים",
      inBook: "בתצוגת ספר",
      opensWinBook: "פתיחת ספר בחלון",
      selectBook: "מסמן את הספר הנוכחי ועובר לספר הבא",
      navBookList: "ניווט ברשימת הספרים",
      pageMove: "תזוזה של עמוד ברשימת הספרים",
      openBookInSepWin: "פתיחת ספר בחלון נפרד",
      mouseClick: "לחיצת עכבר",
      volumesToggle: "פתיחת וסגירת סדרה",
      general: "כללי",
      searchBookById: "חיפוש לפי מספר ספר",
      focusBookInput: "פוקוס בתיבת חיפוש ספר",
      focusFSInput: "פוקוס בתיבת חיפוש חופשי",
      toggleFocus: "העברת הפוקוס מהרשימה לספר לסירוגין",
      togglePagesPanel: "סגירת ופתיחת חלונית עמודים וציונים",
      saveDesktop: "שמירת שולחן עבודה נוכחי",
      doFS: "חיפוש בתוכן הספרים",
      opeRecentBooks: "פתיחת וסגירת רשימת ספרים אחרונים",
      goToPage: "ניווט לדף בספר",
    },
    limitedPage: {
      connectedAsVisitor: "הנך מחובר כאורח",
      shouldPurchase:
        "על מנת לצפות חינם ב150 העמודים הראשונים של הספר עליך להתחבר למערכת.",
      shouldPurchase2: 'צפיה בכל עמודי הספר אפשרית ע"י רכישת מנוי.',
      signIn: "אם הינך מנוי, לחץ כאן להתחברות",
      toPurchase: "לרכישת רשיון הכנס לחנות המקוונת",
      contactDetails: "לפרטים חייג 02-5866078 או במייל chani@otzar.biz",
      blessing: "בברכה, אוצר החכמה",
      workHours: "שעות פעילות המשרד : 8:30 - 16:00",
      bookBelongs: "ספר זה שייך לחבילת ",
      shouldPurchasePackage: "עליך לרכוש מנוי לחבילה זאת על מנת לצפות בספר",
      noOZPurchase: "ספרי עוז והדר לא ניתנים לרכישה כרגע",
      toRegister: "להרשמה, לחץ כאן",
      luachMessage: 'הלוחות יהיו זמינים לצפיה בחודש כסלו תשפ"ה אי"ה',
    },
    mefo: {
      filterByCategory: "סינון לפי קטגוריה",
      noLicense: "לא קיים ברשותך רישיון ל'מפרשי האוצר', ",
      noRambamLicense:
        'מפרשי האוצר על הרמב"ם זמין רק למנויי מפרשי האוצר בגירסה 23 ,',
      noLicenseOnline: "לא קיים ברשותך מנוי ל'מפרשי האוצר'",
      onlyFirstPage: "לכן המפרשים יופיעו רק בעמוד הראשון של הספר.",
      purchaseDetails: "ניתן לרכוש את מפרשי האוצר באופן מקוון",
      purchaseDetailsOffice: "או בטלפון למשרד 'אוצר החכמה' . ",
      purchaseTel: "02-5866078",
      purchase: "לרכישת מפרשי האוצר",
      noViewLicense: "אין לך רשיון לצפות בספר זה",
      noPageViewLicense: "אין לך רשיון לצפות בעמוד זה",
      successfullyCopied:
        "הקטע הועתק בהצלחה - ניתן להדביק אותו במסמכי וורד וכדו'",
      part: "חלק",
      subject: "נושא:",
      shibutz: "לשיבוץ",
      copyPart: "העתק קטע",
      copyShaar: "הצג שער ספר",
      goToPartView: "עבור לתצוגת קטע",
      goToPageView: "עבור לתצוגת עמוד",
      setAsFav: "סמן כמועדף",
      minimize: "מזער",
      toggleFilter: "הפעל/בטל סינון",
      doFilter: "הפעל סינון",
      stopFilter: "בטל סינון",
      hideFilterOptions: "הסתר אפשרויות סינון",
      showFilterOptions: "הצג אפשרויות סינון",
      allResults: "כל התוצאות",
      noPlace: "לא נותר מקום פנוי בשרת. יש לפנות למנהל הרשת לטיפול",
      disconnected: 'נותקת ע"י מנהל הרשת',
      filterOptions: "אפשרויות סינון רשימה:",
      searchPlaceHolder: "חפש ספר או מפרש",
      sortBy: "מיין לפי:",
      defSort: "ברירת מחדל",
      alphaSort: "סדר א-ב",
      goToRowView: "עבור לתצוגת טור",
      goToGridView: "עבור לתצוגת רשת",
      minimAll: "מזער הכל",
      openAll: "פתח הכל",
      dearCust: "לקוח נכבד.",
      purchaseMefError1: "מסיבות טכניות אינך יכול לבצע את הרכישה באופן מקוון.",
      purchaseMefError2: "אנא פנה למשרד לביצוע הרכישה.",
    },
    mmSearch: {
      searchMM: "חפש מראה מקום",
    },
    managePanel: {
      title: "דף ניהול - משתמש מוסדי",
      maxStations: "מספר עמדות מקסימלי:",
      stationsInUse: "עמדות בשימוש:",
      passwordChange: "החלפת סיסמא",
      enterPassword: "הכנס סיסמא",
      generateReports: "הפקת דוחות",
      fromDate: "מתאריך",
      toDate: "עד תאריך",
      generateUsageReport: "הפק דוח שימוש",
      generateFailReport: "הפק דוח כניסות כושלות",
      noPermission: "אין לך הרשאות מנהל",
      disconnectMinutesTitle: "ניתוק עמדה לאחר דקות ללא שימוש",
      recommendChangePass:
        "הינכם משתמשים בסיסמת ברירת המחדל. אנו ממליצים להחליף סיסמא בהקדם.",
      generatingReport: "מפיק את הדוח. אנא המתן... ",
      usageReport: "דוח שימוש",
      failReport: "דוח כניסות כושלות",
      chooseDates: "בחר טווח תאריכים להפקת הדוח.",
    },
    apps: {
      mef: "מפרשי האוצר",
      otzar: "אוצר החכמה",
      both: "אוצר החכמה ומפרשי האוצר",
    },
    gimatriaTool: {
      title: `מחשבון גימטריה בתנ"ך`,
      searchOptions: "אפשרויות חיפוש",
      pasuk: "פסוק שלם",
      partPasuk: "חלק מפסוק",
      bigGim: "גימטריה גדולה",
      smallGim: "גימטריה קטנה",
      withKolel: "עם הכולל",
      types: "סוגי גימטריה",
      enterTxt: "הכנס טקסט לחישוב גימטריה",
    },
    toolbarTabs: {
      changeNameTitleWin: "שינוי שם",
      changeNamePlaceHolder: "הקלד שם טאב",
    },
    messages: {
      showMore: "הצג עוד",
      youHave: "יש לך",
      msgs: "הודעות",
      showLess: "הצג פחות",
      myMessages: "ההודעות שלי",
      new: "חדשות",
      noMessages: "אין לך הודעות",
      iRead: "קראתי",
      readingMsg: "לעיון נוסף בהודעות תוכל תמיד לפתוח את התפריט",
    },
    personalArea: {
      loading: "טוען...",
      personalArea: "איזור אישי",
      mainMenu: "תפריט ראשי",
      extAndAdds: "תוספים והרחבות",
      personalInfo: "פרטים אישים",
      fullName: "שם ומשפחה",
      mosad: "שם המוסד",
      mail: "כתובת מייל",
      miss: "חסר",
      yourMailMissToUs: "כתובת המייל שלך חסרה לנו",
      wePromiseNotPublish: "אנחנו מבטיחים לא להעביר לגורם אחר.",
      didYouChangeInfo: "החלפת כתובת? שינית כתובת מייל?",
      anotherUpdateByMailMsg:
        "שלח לנו מייל לotzar@otzar.biz, וכתוב בנושא ההודעה “עדכון פרטים אישיים”.",
      weUpdateWhenYouHaveInternet:
        "אנו נעדכן אצלינו את המידע מיד, ואתה תוכל לראות אותו כאן בעת חיבור לרשת, או לאחר העדכון הבא שתבצע בדיסק.",
      offlineMailToUpdate:
        "עדכן אותנו במידע זה על ידי שליחתו במייל ל otzar@otzar.biz. בנושא ההודעה כתוב “עדכון פרטים אישיים”.",
      updateMail: "עדכן מייל",
      country: "ארץ",
      landForUs: 'מדינה (לתושבי ארה"ב)',
      city: "עיר",
      address: "רחוב",
      tel: "טלפון",
      cell: "טלפון נייד",
      houseNumber: "מספר בית",
      addInfo: "תוספות והערות",
      sendChanges: "שלח שינויים",
      infoTitle: "עדכון ועריכת פרטים אישיים",
      toUpdateInfo: "לשינוי/הוספת פרטים",
      availableFromVersion: "חבילה זו זמינה מגירסא",
      only: "בלבד!",
      contactUs: "דברו איתנו:",
      explainWhatIsPa:
        "זהו האיזור האישי שלך. נמצאים בו כל הנתונים והמידע, אפשרויות רכישה של ההרחבות השונות, ויצירת קשר עם צוותי השירות שלנו.",
      publicTrasport: "תחבורה ציבורית",
      localBusLines: "קווי אוטובוסים פנימיים:",
      openhours: "שעות פעילות:",
      opendays: "א' - ה'",
      disktoonline: {
        title: "המרה למקוון-קשיח",
        m1: "האם הרשת זמינה עבורך באופן קבוע?",
        m2: "האם אתה משתמש ב'אוצר החכמה' ביותר ממחשב אחד?",
        m3: "נשיאת הדיסק מכבידה עליך?",
        m4: "האם הדיסק ניזוק/נשבר לעתים קרובות מדי?",
        m5: "אם ענית 'כן' לאחת מהשאלות הללו, מעבר לשימוש בתוכנה המקוונת שלנו הוא הפתרון המושלם עבורך!",
        m6: "אנו מזמינים אותך לעבור מגרסת הדיסק הקשיח המסורתית לתוכנה המקוונת.",
        m7: `שדרוג זה מציע לך גישה נוחה מכל מחשב, בכל זמן ומקום, עם שם משתמש וסיסמה בלבד, ומבטל את הצורך בחיבור פיזי לדיסק. התוכנה המקוונת
 מתעדכנת באופן קבוע ומאפשרת לך להנות תמיד מהגירסה העדכנית ביותר.`,
        m8: `עמלה שנתית:`,
        m9: `השימוש במנוי המקוון ללקוחות הדיסק, מותנה בתשלום של 450 ש"ח בלבד בשנה`,
        m10: `(התשלום יחל להתבצע כעבור שנה מעת ביצוע המעבר למקוון).`,
        m11: `נקודות חשובות לתשומת לב:`,
        m12: `הגירסה בדיסק הקשיח צריכה להיות העדכנית ביותר (אם לא, עליך לשלם את עלות עדכונו של הדיסק לגירסה העדכנית).`,
        m13: "הגישה המקוונת שלך תהיה זהה למהדורת הדיסק (מלאה / בני תורה) ולחבילות הנוכחיות שלך.",
        m14: `לא יתאפשר שימוש מקביל בדיסק הקשיח ובגרסה המקוונת. לכן התוכנה בדיסק שלך תושעה עם המעבר.`,
        m15: `גם לאחר המעבר לשימוש מקוון, זכויותיך כלקוח 'דיסק קשיח' של אוצר החכמה יישמרו, ותמיד תוכל לבטל את ההסכם ולחזור להשתמש בדיסק הקשיח, בהתאם לתנאי החוזה.`,
        m16: "כל התנאים וההגבלות מפורטים בחוזה, אנו ממליצים לקרוא אותו בעיון.",
        agree: "לפרטי ההסכם",
        downloadAgree: "מילוי טופס המעבר",
      },
      diskInfo: {
        diskCap: "שטח הדיסק:",
        diskUsed: "בשימוש",
        diskFree: "שטח פנוי",
      },
      extArea: {
        phoneAlso: "זמין גם ברכישה טלפונית!",
        dontHaveMef: "אין לך עדיין את מפרשי האוצר",
        greatNews: "‘מפרשי האוצר’: הבשורה לציבור לומדי הגמרא!",
        mefo_explain: `סמן שורה או קטע בדף הגמרא, רש”י או תוספות, וכהרף עין יופיעו כל הפירושים העוסקים בקטע זה, מתוך הספרים הקיימים ב'אוצר': שיעורים, חידושים, קושיות, תירוצים, שינויי נוסחאות, וכל מה שדנו וחידשו מפרשי הדורות.`,
        eyesLook: "אין טוב ממראה עיניים",
        tryFirstPage: "באפשרותך להתנסות ב’מפרשי האוצר’ על הדף הראשון בכל מסכת:",
        mefo_explain2: `מתוך דף הבית, בחר את המסכת הרצויה ופתח את העמוד הראשון שלה. התחל בסימון הקטע עליו תרצה לקבל את כל קטעי המפרשים. התוצאות יופיעו בזו אחר זו. בהצלחה!`,
        after_pay: "לאחר הרכישה, השימוש יתאפשר באופן מיידי, ללא פעולה נוספת.",
        includeInOtzar: "כלול באוצר שלך!",
        machonBooks: "ספרי מכונים",
        youHave: "באוצר שלך כבר קיימים החבילות הבאות",
        dontHaveAnything: "אין לך חבילות באוצר שלך",
        buyAndUse: "רכוש עכשיו, והתחל להשתמש מיידית:",
        haveCode: "יש לך קוד? הזן אותו כאן",
        codeNum: "מספר הקוד",
        notUpdated: "אין לך את הגירסה המעודכנת!",
        sendToOffice: "לצורך השלמת השדרוג, יש לשלוח את הדיסק למשרד.",
        versionUpgrade: "שדרוג גירסה",
        openNewBooksList: "פתח רשימת הספרים החדשים",
        upgradeNow: "שדרג עכשיו לגירסה",
      },
      extExplainOnMefBuy: {
        didYouKnow: "הידעת!",
        buyAndUse:
          "ניתן לרכוש את מפרשי האוצר והרחבות ספרי המכונים בכרטיס אשראי בטלפון, ולהתחיל להשתמש בהם תכף ומיד...!",
        howItWorks: "איך זה עובד...?",
        step1: "התקשר אלינו ושלם בכרטיס אשראי עבור ההרחבות שבחרת.",
        step2: "לאחר התשלום תקבל קוד, אותו עליך להזין כאן.",
        step3: "הזן את הקוד והתחל להשתמש",
        fromVer: "החל מגירסה 19 ומעלה",
      },
      mainPersonalMenu: {
        asWeHaveIt: "פרטי הלקוח כפי שהם מופיעים ברשומותינו.",
        changeInfoAlert:
          "החלפת כתובת? שינית כתובת מייל? כאן תוכל לעדכן את השינויים.",
        infoWeHave: "נתוני התוכנה שברשותך",
        infoMsg1: "פרטי הגירסה, סוג החומרה, תכולתה, ועוד.",
        infoMsg2: "מידע על מפרשי האוצר וחבילות ספרי המכונים. רכישה זמינה.",
        infoMsg3: "המרת דיסק קשיח למקוון",
        infoMsg4: "כל המידע והפרטים, ומילוי טופס המעבר",
        infoMsg5: "פתיחת פניה לקבלת שירות ותמיכה טכנית.",
        infoMsg6: "פרטי יצירת קשר.",
        infoMsg7: "צפייה בהודעות שלי.",
      },
      noInternet: {
        msg1: "הנך משתמש במחשב ללא חיבור לרשת.",
        msg2: "שים לב!",
        msg3: "חלק מהפעולות אינן מתאפשרות ללא חיבור זה",
        msg4: "הנתונים באיזור האישי מעודכנים לתאריך האחרון בו בוצע עדכון הדיסק האחרון",
      },
      updateInfoMsgs: {
        clientInfo: "פרטי לקוח:",
        clientNumber: "מספר לקוח",
        version: "גירסא",
        subVersion: "תת עדכון",
        netStationOtzar: "עמדות רשת אוצר החכמה",
        netStationMefo: "עמדות רשת מפרשי האוצר",
        HardwareInfo: "פרטי החומרה",
        SerialNumber: "מספר סריאלי",
      },
      subject: "נושא",
      updateMyMail1: "עדכנו בפרטי האישיים",
      updateMyMail2: "את המייל ",
      subjects: {
        s1: "דיסק תקול",
        s2: "תקלה בתוכנה",
        s3: 'חומר אוצה"ח שגוי',
        s4: "אחר",
      },
    },
    recentPages: {
      myheader: "דפים אחרונים",
      myplaceholder: "ריק",
    },
    typed: "הוקלדו",
    screenMessages: {
      NEW_OZ_MSG:
        "<center><b>רכשת בהצלחה את חבילת עוז והדר המורחבת.</b><br><br><br><div style='border: 1px solid var(--custom-color1); min-width: 40px;  text-align: center;   background-color: var(--custom-color1);  border-radius: 17px;   position: relative; font-size: 16px;line-height: 16px;padding: 0 6px;color: #fff;cursor: pointer;white-space: nowrap;height:35px' onclick='globalThis.doOzDownload()'> לחץ כאן להורדת הספרים החדשים של עוז והדר <span style='font-size:20px;line-height:30px'>&#8609;</span></div>",
      ONLINE_UPGRADE_MSG: `
    <p>
      רכשתם את גרסה 23.0, כעת עליכם ללחוץ על הכפתור למטה לצורך התקנת השדרוג.
    </p>
    <p class="warning">
      שימו לב: התוכנה הנוכחית תיסגר, תהליך ההורדה עשוי להימשך מספר שעות. יש להשאיר את התוכנה סגורה במהלך כל זמן ההורדה.
    </p>
    <div style='margin-top:13px;border: 1px solid var(--custom-color1); min-width: 40px;  text-align: center;   background-color: var(--custom-color1);  border-radius: 17px;   position: relative; font-size: 16px;line-height: 16px;padding: 0 6px;color: #fff;cursor: pointer;white-space: nowrap;height:35px'
      class="button"
      onclick="globalThis.doOnlineUpgrade()"
    >
      הפעלת התוכנה להורדת השדרוג
  <span style='font-size:20px;line-height:30px'>&#8609;</span>  </div>
  </div>`,
      //  "<center><b>רכשת בהצלחה את גירסה 23.0.</b><br><br><br><div style='border: 1px solid var(--custom-color1); min-width: 40px;  text-align: center;   background-color: var(--custom-color1);  border-radius: 17px;   position: relative; font-size: 16px;line-height: 16px;padding: 0 6px;color: #fff;cursor: pointer;white-space: nowrap;height:35px' onclick='globalThis.doOnlineUpgrade()'> לחץ כאן להשלמת השדרוג<span style='font-size:20px;line-height:30px'>&#8609;</span></div>",
    },
    ozWarning:
      "    הוספת ספרי הרחבת עוז והדר, תהיה זמינה להורדה בימים הקרובים ותקבלו הודעה על כך    ",
    pagesPicker: {
      previewPlaceHolder: "חלונית תצוגה מקדימה",
      preview: "תצוגה מקדימה",
      header: "כותרת",
      page: "עמוד",
    },
    documents: {
      name: "מסמכים, טפסים והצהרות",
      privateDisk: "דיסק פרטי",
      lostDisk: "דיסק שאבד",
      DiskRestoredFromRepair: "דיסק ששוחזר מתיקון",
      FilePath: location.protocol + "//" + location.host + "/",
      FilePathElectron: globalThis.APP_URL_SHORT
        ? globalThis.APP_URL_SHORT + "/"
        : "",
      privateDiskFileName: "static/privateDisk_he.pdf",
      lostDiskFileName: "static/lostDisk_he.pdf",
      DiskRestoredFromRepairFileName: "static/DiskRestoredFromRepair_he.pdf",
    },
  },
};
// module.exports = messages;
export default messages;
